import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Resource: { input: any; output: any; }
};

/** An email field */
export type AdditionalEmailField = AdditionalField & {
  __typename?: 'AdditionalEmailField';
  /** Email address value of the additional field */
  email: Scalars['String']['output'];
  /** The field label of an additional field */
  label: Scalars['String']['output'];
};

/** An additional field interface */
export type AdditionalField = {
  /** The field label of an additional field */
  label: Scalars['String']['output'];
};

/** A file list field */
export type AdditionalFileListField = AdditionalField & {
  __typename?: 'AdditionalFileListField';
  /** List of file resources of the additional field */
  files: Array<File>;
  /** The field label of an additional field */
  label: Scalars['String']['output'];
};

/** An image list field */
export type AdditionalImageListField = AdditionalField & {
  __typename?: 'AdditionalImageListField';
  /** List of image resources of the additional field */
  images: Array<Image>;
  /** The field label of an additional field */
  label: Scalars['String']['output'];
};

/** A link url field */
export type AdditionalLinkField = AdditionalField & {
  __typename?: 'AdditionalLinkField';
  /** The field label of an additional field */
  label: Scalars['String']['output'];
  /** Link target value of the additional field */
  target: Scalars['String']['output'];
  /** Link text value of the additional field */
  text: Scalars['String']['output'];
  /** Link url value of the additional field */
  url: Scalars['String']['output'];
};

/** A multiline HTML text field */
export type AdditionalMultilineField = AdditionalField & {
  __typename?: 'AdditionalMultilineField';
  /** The field label of an additional field */
  label: Scalars['String']['output'];
  /** HTML multiline text value of the additional field */
  text: Scalars['String']['output'];
};

/** A file list field */
export type AdditionalSocialMediaField = AdditionalField & {
  __typename?: 'AdditionalSocialMediaField';
  /** The field label of an additional field */
  label: Scalars['String']['output'];
  /** The social media platform */
  platform: SocialMediaPlatform;
  /** Direct url to the social media platform */
  url: Scalars['String']['output'];
};

/** An agenda item object representation */
export type AgendaItem = {
  __typename?: 'AgendaItem';
  /** List of additional content fields */
  additionalFields: Array<AdditionalField>;
  /** The description of the object in HTML format */
  description: Scalars['String']['output'];
  /** End date of the object */
  endDate: Scalars['DateTime']['output'];
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** The main image of the object */
  image?: Maybe<Image>;
  /** The lead text of the object with a maximum length of 100 characters. If no lead text is specified, the cropped description in plain text is returned. */
  lead: Scalars['String']['output'];
  /** The speakers of the object */
  speakers: Array<Speaker>;
  /** Start date of the object */
  startDate: Scalars['DateTime']['output'];
  /** List of tags */
  tags: Array<Scalars['String']['output']>;
  /** The title of the object */
  title: Scalars['String']['output'];
  /** The venue of this object. Further venues might be applied on other nodes within the event tree. */
  venue?: Maybe<Venue>;
};

/** App configuration collection */
export type App = {
  __typename?: 'App';
  /** The supported authentication methods for global access. The first method in the list is seen as the default. */
  authenticationMethods: Array<AuthenticationMethod>;
  /** App branding settings */
  branding: BrandingSetting;
  /** Flag if event creation is enabled */
  eventCreation: Scalars['Boolean']['output'];
  /** App language settings */
  language: Language;
  /** Flag if the user registration is enabled */
  userRegistration: Scalars['Boolean']['output'];
};

/** An asset interface */
export type Asset = {
  /** Asset captain */
  caption: Scalars['String']['output'];
  /** Asset title */
  title: Scalars['String']['output'];
};

/** Authentication context with create token mutations */
export type Authentication = {
  __typename?: 'Authentication';
  /** Create an event specific Json Web Token by an access code. */
  createTokenByAccessCode?: Maybe<TokenMutationOutput>;
  /** Create a Json Web Token by an application token. */
  createTokenByAppToken?: Maybe<TokenMutationOutput>;
  /** Create a Json Web Token by an event token. */
  createTokenByEventToken?: Maybe<TokenMutationOutput>;
  /** Create an event specific Json Web Token by the participant access identifier. */
  createTokenByParticipant?: Maybe<TokenMutationOutput>;
  /** Create a Json Web Token by a given username and password. */
  createTokenByUsernamePassword?: Maybe<TokenMutationOutput>;
  /** Get the URI to be called for single sign on. Result is undefined if there is no SSO available */
  getSsoUri?: Maybe<Scalars['String']['output']>;
};


/** Authentication context with create token mutations */
export type AuthenticationCreateTokenByAccessCodeArgs = {
  accessCode: TokenCreateByAccessCodeInput;
};


/** Authentication context with create token mutations */
export type AuthenticationCreateTokenByAppTokenArgs = {
  appToken: TokenCreateByAppTokenInput;
};


/** Authentication context with create token mutations */
export type AuthenticationCreateTokenByEventTokenArgs = {
  eventToken: TokenCreateByEventTokenInput;
};


/** Authentication context with create token mutations */
export type AuthenticationCreateTokenByParticipantArgs = {
  participant: TokenCreateByParticipantInput;
};


/** Authentication context with create token mutations */
export type AuthenticationCreateTokenByUsernamePasswordArgs = {
  usernamePassword: TokenCreateByUsernamePasswordInput;
};


/** Authentication context with create token mutations */
export type AuthenticationGetSsoUriArgs = {
  callbackUri: Scalars['String']['input'];
};

/** Frontend user authentication types. An authentication is initiated via a createTokenByXyz mutation. */
export enum AuthenticationMethod {
  /** Authentication by an access code. */
  AccessCode = 'ACCESS_CODE',
  /** Authentication as a service account by an app token */
  AppToken = 'APP_TOKEN',
  /** Authentication as a service account by an event token */
  EventToken = 'EVENT_TOKEN',
  /** Authentication by a participant accessIdentifier via PURL */
  PersonalUrl = 'PERSONAL_URL',
  /** Authentication by public access */
  PublicAccess = 'PUBLIC_ACCESS',
  /** Authentication by the single sign on process. */
  Sso = 'SSO',
  /** Authentication by a given username and password. */
  UsernamePassword = 'USERNAME_PASSWORD'
}

/** Booking limit and target restrictions */
export type Bookable = {
  __typename?: 'Bookable';
  /** Maximum bookable by the viewer */
  maximum: Scalars['Int']['output'];
  /**
   * Number of possible companions. 0 if disabled. Null if unlimited.
   *
   * If it is multiple bookable by the user, companions are always disabled.
   */
  maximumCompanions?: Maybe<Scalars['Int']['output']>;
  /** Minimum bookable by the viewer */
  minimum: Scalars['Int']['output'];
  /** Validation error status if the object cannot be booked. The validation does not include any availability limitations. */
  validationErrorStatus?: Maybe<BookableValidationStatus>;
  /** Flag if the booking is done on the waitinglist */
  waitinglist: Scalars['Boolean']['output'];
};

/** Bookable validation status for operations */
export enum BookableValidationStatus {
  /** There is already a booking for this single bookable event. */
  EventMultibookableConflict = 'EVENT_MULTIBOOKABLE_CONFLICT',
  /** The event status is not bookable. Bookable statuses are: Active, Closed */
  EventStatusNotBookable = 'EVENT_STATUS_NOT_BOOKABLE',
  /** All operation dates are in the past. */
  OperationDatesNotActive = 'OPERATION_DATES_NOT_ACTIVE',
  /** The operation deadline which overwrites the registration end date is expired. */
  OperationDeadlineExpired = 'OPERATION_DEADLINE_EXPIRED',
  /** The operation status is not bookable. Bookable statuses are: Active */
  OperationStatusNotBookable = 'OPERATION_STATUS_NOT_BOOKABLE',
  /** The viewer registration is not running */
  RegistrationNotRunning = 'REGISTRATION_NOT_RUNNING'
}

/** A booking object representation */
export type Booking = {
  __typename?: 'Booking';
  /** Booking reference number */
  bookingNr: Scalars['String']['output'];
  /** The booked operation objects */
  bookingOperations: Array<BookingOperation>;
  /** The booking status. For each booking operation, the booking operation status has to be put in context with the booking status. */
  bookingStatus: BookingStatus;
  /** Booking creation date */
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Flag if the booking can be deleted. The flag is depending on the booking status, payment, and operation settings. */
  deletable: Scalars['Boolean']['output'];
  /**
   * Discount amount according to the `includingVat` flag.
   *
   * This discount amount is calculated by a fix discount amount or percentage. Both can be set on the registration object or by access or voucher codes. Various combinations are possible.
   */
  discount: Scalars['Float']['output'];
  /** The VAT amount applied on the `discountPercentage` calculated by `vatRate` */
  discountVatPrice: Scalars['Float']['output'];
  /** E-ticket url to the download handler */
  eTicketUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Aggregated booking operation objects grouped by operations.
   *
   * This may be used for displaying booking overviews in case of multi-bookable operations as it contains the total quantity of booked operations.
   */
  groupedBookingOperations: Array<BookingOperationAggregation>;
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** Flag stating whether the booking was done with prices including or excluding VAT. */
  includingVat: Scalars['Boolean']['output'];
  /** Booking input fields entered during the booking process */
  inputFieldValues: Array<InputFieldValue>;
  /** The participant the booking belongs to */
  participant: ViewerParticipant;
  /** Payment object if there is payment applied. It contains the overall sums of the booking costs. */
  payment?: Maybe<Payment>;
  /** Registration price according to the `includingVat` flag. This price comes form the registration object. */
  registrationPrice: Scalars['Float']['output'];
  /** The VAT amount applied on the `registrationPrice` calculated by `vatRate` */
  registrationVatPrice: Scalars['Float']['output'];
  /** The VAT rate taken from the registration object and applied on `registrationPrice` and `discount` fields. It may vary from the overall applied vat on the payment object. */
  vatRate: Scalars['Float']['output'];
};

/** Aggregated participant counts for all active bookings. */
export type BookingAggregation = {
  __typename?: 'BookingAggregation';
  /** Total active bookings with booking operation status confirmed. */
  confirmed: Scalars['Int']['output'];
  /** Total active bookings with booking operation status invited. */
  invited: Scalars['Int']['output'];
  /** Total active bookings with booking operation status confirmed, invited, waiting and full. */
  total: Scalars['Int']['output'];
  /** Total active bookings with booking operation status waiting. */
  waiting: Scalars['Int']['output'];
};

/** Input type to create a new booking object */
export type BookingCreateInput = {
  /** List of booking operations that will that will be added to the new booking. */
  bookingOperations: Array<BookingOperationCreateInput>;
  /** New companion objects */
  companions?: InputMaybe<Array<CompanionBookingOperationCreateInput>>;
};

/** A Booking mutation response object */
export type BookingMutationOutput = MutationOutput & {
  __typename?: 'BookingMutationOutput';
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** The mutated Booking */
  object?: Maybe<Booking>;
};

/** A booking operation object representation */
export type BookingOperation = {
  __typename?: 'BookingOperation';
  /** The booking operation status. The status has to be seen in relation with the booking status. */
  bookingOperationStatus: BookingOperationStatus;
  /** The associated companion */
  companion?: Maybe<Companion>;
  /**
   * Flag if the booking operation can be deleted. The flag is depending on the booking
   *
   *                         status, payment, booking operation status and operation settings.
   */
  deletable: Scalars['Boolean']['output'];
  /**
   * Discount amount according to the booking's `includingVat` flag.
   *
   * This discount amount is calculated by a percentage set on the registration object. Various combinations are possible.
   */
  discount: Scalars['Float']['output'];
  /**
   * Discount percentage applied to this booking operation.
   *
   * The percentage can be a combination of different discounts. (cf. `discount` field)
   */
  discountPercentage: Scalars['Float']['output'];
  /** The VAT amount applied on the `discountPercentage` calculated by `vatRate` */
  discountVatPrice: Scalars['Float']['output'];
  /** The associated group for operations with enabled group bookings. */
  groupBooking?: Maybe<GroupBooking>;
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** Booking operation input fields entered during the booking process */
  inputFieldValues: Array<InputFieldValue>;
  /** The booked operation. */
  operation: Operation;
  /**
   * Operation price according to the booking's `includingVat` flag.
   *
   * This price is taken by the operation or a price rule applied to the operation.
   */
  operationPrice: Scalars['Float']['output'];
  /** Total booking operation price according to the booking's `includingVat` flag */
  totalPrice: Scalars['Float']['output'];
  /** The total VAT amount of this booking operation */
  totalVatPrice: Scalars['Float']['output'];
  /** The VAT rate applied to this booking operation. It may vary from the overall applied vat on the payment object. */
  vatRate: Scalars['Float']['output'];
};

/** Aggregated booking operation objects */
export type BookingOperationAggregation = {
  __typename?: 'BookingOperationAggregation';
  /** The booking operation status. The status has to be seen in relation with the booking status. */
  bookingOperationStatus: BookingOperationStatus;
  /** All aggregated booking operation objects of this collection. */
  bookingOperations: Array<BookingOperation>;
  /** Aggregated number of all booking operation objects. */
  count: Scalars['Int']['output'];
  /**
   * Discount amount according to the booking's `includingVat` flag.
   *
   * This discount amount is calculated by a percentage set on the registration object. Various combinations are possible.
   */
  discount: Scalars['Float']['output'];
  /** Discount percentage applied to this booking operation. The percentage can be a combination of different discounts. (cf. `discount` field) */
  discountPercentage: Scalars['Float']['output'];
  /** The VAT amount applied on the `discountPercentage` calculated by `vatRate` */
  discountVatPrice: Scalars['Float']['output'];
  /** The booked operation. */
  operation: Operation;
  /**
   * Operation price according to the booking's `includingVat` flag.
   *
   * This price is taken by the operation or a price rule applied to the operation.
   */
  operationPrice: Scalars['Float']['output'];
  /** Total booking operation price according to the booking's `includingVat` flag */
  totalPrice: Scalars['Float']['output'];
  /** The total VAT amount of this booking operation */
  totalVatPrice: Scalars['Float']['output'];
  /** The VAT rate applied to this booking operation. It may vary from the overall applied vat on the payment object. */
  vatRate: Scalars['Float']['output'];
};

/** Input type to create a new booking operation object of a booking */
export type BookingOperationCreateInput = {
  /** UUID of an existing companion or of a companion added for creation on the parent type */
  companionId?: InputMaybe<Scalars['ID']['input']>;
  /** UUID of a joining group booking. Either a groupBookingId or a newGroupBooking is required for group bookings. */
  groupBookingId?: InputMaybe<Scalars['ID']['input']>;
  /** Input field values according to the bookable operation */
  inputFieldValues?: InputMaybe<Array<InputFieldValueInput>>;
  /** New group booking object. Either a groupBookingId or a newGroupBooking is required for group bookings. */
  newGroupBooking?: InputMaybe<GroupBookingCreateInput>;
  /** UUID of the operation */
  operationId: Scalars['ID']['input'];
};

/** A BookingOperation mutation response object */
export type BookingOperationMutationOutput = MutationOutput & {
  __typename?: 'BookingOperationMutationOutput';
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** The mutated BookingOperation */
  object?: Maybe<BookingOperation>;
};

/** Booking operation status */
export enum BookingOperationStatus {
  /** Booking operation is confirmed. */
  Confirmed = 'CONFIRMED',
  /** The booking operation got deleted. */
  Deleted = 'DELETED',
  /** The operation is fully booked and cannot be confirmed. */
  Full = 'FULL',
  /** The booking operation got invited after being waiting. It is ready to be confirmed by the user. */
  Invited = 'INVITED',
  /** Booking operation is on the waiting list */
  Waiting = 'WAITING'
}

/** A multi-BookingOperation mutation response object */
export type BookingOperationsMutationOutput = {
  __typename?: 'BookingOperationsMutationOutput';
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** The mutated BookingOperations */
  objects?: Maybe<Array<BookingOperation>>;
};

/** Booking status */
export enum BookingStatus {
  /** The booking got cancelled during the booking process. The reserved booking never got confirmed. */
  Cancelled = 'CANCELLED',
  /** Booking is confirmed */
  Confirmed = 'CONFIRMED',
  /** The booking got deleted after it was confirmed */
  Deleted = 'DELETED',
  /** Unconfirmed booking expired 15 min. after it got created with status reserved. */
  Expired = 'EXPIRED',
  /** Status of a created booking with one or more booking operation with status full. An invalid booking cannot be confirmed. */
  Invalid = 'INVALID',
  /** Status for ticketing case: A reservation (with booking) approved by a ticket coordinator, but pending for final approval by an admin. */
  Pending = 'PENDING',
  /** Status for ticketing case: A reservation (with booking) got created but was rejected. */
  Rejected = 'REJECTED',
  /** Status for ticketing case: A reservation (with booking) got created but is pending for approval. */
  Requested = 'REQUESTED',
  /** Status of a created but not yet confirmed booking. A reserved booking expires after 15 min. if it does not get confirmed. */
  Reserved = 'RESERVED',
  /** Status of a paid booking that got expired during payment process. An administrator has to manually confirm or delete the booking. This is a very exceptional case. */
  Tentative = 'TENTATIVE'
}

/** Input type to update an existing booking object */
export type BookingUpdateInput = {
  /** List of booking operations that will replace the existing booking operations of the booking. */
  bookingOperations?: InputMaybe<Array<BookingOperationCreateInput>>;
  /** New companion objects */
  companions?: InputMaybe<Array<CompanionBookingOperationCreateInput>>;
  /** UUID of the booking */
  id: Scalars['ID']['input'];
  /** Input field values according to the booked registration */
  inputFieldValues?: InputMaybe<Array<InputFieldValueInput>>;
};

/** Input field value of type boolean */
export type BooleanInputFieldValue = InputFieldValue & {
  __typename?: 'BooleanInputFieldValue';
  /** The parsed value of type boolean */
  booleanValue: Scalars['Boolean']['output'];
  /** The input field for this value */
  inputField: InputField;
};

/** branding settings */
export type BrandingSetting = {
  __typename?: 'BrandingSetting';
  /** The branding background color as hex value */
  backgroundColor: Scalars['String']['output'];
  /** The branding font family */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The branding font file provided as CSS src to embed */
  fontFile?: Maybe<Scalars['Resource']['output']>;
  /** Font source */
  fontSource?: Maybe<FontSource>;
  /** The logo image */
  logo?: Maybe<Image>;
  /** The branding primary color as hex value */
  primaryColor: Scalars['String']['output'];
  /** The branding secondary color as hex value */
  secondaryColor: Scalars['String']['output'];
};

/** A cancellation object representation */
export type Cancellation = {
  __typename?: 'Cancellation';
  /** Cancellation creation date */
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** The participant the cancellation belongs to */
  participant: ViewerParticipant;
};

/** Input type to create a new cancellation object */
export type CancellationCreateInput = {
  /** Participant input */
  participant?: InputMaybe<ParticipantCreateInput>;
};

/** A Cancellation mutation response object */
export type CancellationMutationOutput = MutationOutput & {
  __typename?: 'CancellationMutationOutput';
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** The mutated Cancellation */
  object?: Maybe<Cancellation>;
};

/** Capacity definition for operations and waitinglists */
export type Capacity = {
  __typename?: 'Capacity';
  /** Total available slots. The value is undefined if there is no limitation. */
  available?: Maybe<Scalars['Int']['output']>;
  /** Maximum bookings available. The value is undefined if there is no limitation. */
  maximum?: Maybe<Scalars['Int']['output']>;
  /** Minimum bookings required. The value is undefined if there is no limitation. */
  minimum?: Maybe<Scalars['Int']['output']>;
};

/** A category object representation */
export type Category = {
  __typename?: 'Category';
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  name: Scalars['String']['output'];
};

/** A category teaser consolidated with the most relevant information for more performant queries. */
export type CategoryTeaser = {
  __typename?: 'CategoryTeaser';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Check-in status */
export type CheckIn = {
  __typename?: 'CheckIn';
  /** Flag if the participant has attended */
  attendance: Scalars['Boolean']['output'];
  /** Date on which the attendance got registered by a check-in application. */
  attendanceDate?: Maybe<Scalars['DateTime']['output']>;
  /** Dates on which the attendance got registered by a check-in application. */
  attendanceDates: Array<Scalars['DateTime']['output']>;
};

export type CheckInUpdateInput = {
  /** Flag if the participant is attending */
  attendance: Scalars['Boolean']['input'];
  /** Date of the check-in */
  attendanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Dates of multiple check-ins */
  attendanceDates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** UUID of the EventCheckIn object. Internally, this is the id of the BookingOperation. */
  id: Scalars['ID']['input'];
};

/** A EventCheckIn mutation response object */
export type CheckInUpdateMutationOutput = MutationOutput & {
  __typename?: 'CheckInUpdateMutationOutput';
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** The mutated EventCheckIn */
  object?: Maybe<EventCheckIn>;
};

/** Checkbox form element */
export type CheckboxField = InputField & {
  __typename?: 'CheckboxField';
  /** Default value as preset for the control */
  defaultValue: Scalars['Boolean']['output'];
  /** The field identifier */
  identifier: Scalars['String']['output'];
  /** The field label. If not overwritten, the label is equal to the identifier. */
  label: Scalars['String']['output'];
  /** Flag stating the value as required. */
  required: Scalars['Boolean']['output'];
};

/** Data collection interface */
export type Collection = {
  /** Number of returned items based on filter and limit */
  itemCount: Scalars['Int']['output'];
  /** The returned items */
  items: Array<CollectionItem>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
};

/** Possible items for collections */
export type CollectionItem = Comment | Event | EventAccess | EventCheckIn | EventTeaser | GenericParticipant | GroupBooking | Speaker | Venue;

/** Collection of Event objects */
export type CollectionLimt = {
  /** Maximum results for the collection */
  length?: InputMaybe<Scalars['Int']['input']>;
  /** First result for slicing */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Comment = {
  __typename?: 'Comment';
  /** Date time of creation */
  creationDate: Scalars['DateTime']['output'];
  /** Flag if the comment is deletable by the authenticated viewer */
  deletable: Scalars['Boolean']['output'];
  /** Full name of the writer */
  displayName: Scalars['String']['output'];
  /** First name of the writer */
  firstName: Scalars['String']['output'];
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** Last name of the writer */
  lastName: Scalars['String']['output'];
  /** The comment text */
  text: Scalars['String']['output'];
  /** The thumbnail image of the writer. This is either the thumbnail of the related participant or user. */
  thumbnail?: Maybe<Image>;
  /** The user profile id if available */
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Comment collection */
export type CommentCollection = Collection & {
  __typename?: 'CommentCollection';
  /** Number of returned items based on filter and limit */
  itemCount: Scalars['Int']['output'];
  /** The returned comments */
  items: Array<Comment>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
};

/** Input type to create a new comment object */
export type CommentCreateInput = {
  captcha?: InputMaybe<Scalars['String']['input']>;
  /** Comment text input */
  text: Scalars['String']['input'];
};

/** A Comment mutation response object */
export type CommentMutationOutput = MutationOutput & {
  __typename?: 'CommentMutationOutput';
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** The mutated Comment */
  object?: Maybe<Comment>;
};

/** A companion object representation */
export type Companion = Person & {
  __typename?: 'Companion';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** UUID of the companion object */
  id: Scalars['ID']['output'];
  /** Companion's input fields entered during the booking process */
  inputFieldValues: Array<InputFieldValue>;
  /** The identifier of the participant's language */
  language?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  /** The participant thumbnail image (portrait) */
  thumbnail?: Maybe<Image>;
};

/** Input type to create a new companion */
export type CompanionBookingOperationCreateInput = {
  /** UUID of the companion that is referenced inside the BookingOperationCreateInput type */
  id: Scalars['ID']['input'];
  /** Input field values according to the participant definition */
  inputFieldValues: Array<InputFieldValueInput>;
};

/** Input type to create a new companion */
export type CompanionCreateInput = {
  /** Input field values according to the participant definition */
  inputFieldValues: Array<InputFieldValueInput>;
};

/** A content section object representation */
export type ContentSection = {
  __typename?: 'ContentSection';
  /** List of additional content fields */
  additionalFields: Array<AdditionalField>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** A currency object representation */
export type Currency = {
  __typename?: 'Currency';
  name: Scalars['String']['output'];
};

/** Input field value of type date */
export type DateInputFieldValue = InputFieldValue & {
  __typename?: 'DateInputFieldValue';
  /** The parsed value of type date time */
  dateValue?: Maybe<Scalars['DateTime']['output']>;
  /** The input field for this value */
  inputField: InputField;
};

/** Date picker form element */
export type DatePickerField = InputField & {
  __typename?: 'DatePickerField';
  /** Default value as preset for the control */
  defaultValue?: Maybe<Scalars['DateTime']['output']>;
  /** The field identifier */
  identifier: Scalars['String']['output'];
  /** The field label. If not overwritten, the label is equal to the identifier. */
  label: Scalars['String']['output'];
  /** Flag stating the value as required. */
  required: Scalars['Boolean']['output'];
};

/** A timezone representation */
export type DateTimeZone = {
  __typename?: 'DateTimeZone';
  /** Indicates if the timezone is custom or default */
  default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Offset to UTC */
  offset: Scalars['Int']['output'];
};

/** Error type to propagate errors to the client */
export type Error = {
  __typename?: 'Error';
  /** Error message */
  message: Scalars['String']['output'];
  /** Error code for references in log files */
  referenceCode?: Maybe<Scalars['Int']['output']>;
};

/** An event object representation. An event is modelled as a node tree mainly consisting of events, operations and dates. */
export type Event = EventNode & {
  __typename?: 'Event';
  /** List of additional content fields */
  additionalFields?: Maybe<Array<AdditionalField>>;
  /** The agenda of the event */
  agenda?: Maybe<Array<AgendaItem>>;
  /** Flag if agenda feature is enabled. If disabled, the agenda array is empty. */
  agendaFeature?: Maybe<Scalars['Boolean']['output']>;
  /** A single agenda item by identifier. Any agenda item within the event can be requested. */
  agendaItem?: Maybe<AgendaItem>;
  /** The supported authentication methods of this event ordered by priority. The first method in the list is seen as the default. */
  authenticationMethods: Array<AuthenticationMethod>;
  /** Event specific branding settings */
  branding?: Maybe<BrandingSetting>;
  /** Capacity information for the event */
  capacity?: Maybe<EventCapacity>;
  /** List of categories assign to the object */
  categories?: Maybe<Array<Category>>;
  /** Flag if the check-ins contain personal data of the participants */
  checkInParticipantDetails?: Maybe<Scalars['Boolean']['output']>;
  /** All check-in entities for the event */
  checkIns?: Maybe<EventCheckInCollection>;
  /** Flag if comment feature is generally enabled. */
  commentFeature?: Maybe<Scalars['Boolean']['output']>;
  /** Comments added to this event. If the comments feature is not available, the field is null. */
  comments?: Maybe<CommentCollection>;
  /** Earliest operation deadline or registration end date. */
  deadline?: Maybe<Scalars['DateTime']['output']>;
  /** The description of the object in HTML format */
  description?: Maybe<Scalars['String']['output']>;
  /** Latest end date over all operation dates. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The event type of the event */
  eventType: EventType;
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** The main image of the object */
  image?: Maybe<Image>;
  /** Event key also used as partial url */
  key: Scalars['String']['output'];
  /** Event language settings */
  language: Language;
  /** The selected template layout */
  layout: Layout;
  /**
   * The lead text of the object with a maximum length of 100 characters. If no lead text is specified, the cropped description in plain text is returned.
   * @deprecated Not supported anymore
   */
  lead?: Maybe<Scalars['String']['output']>;
  /** The lowest price across all bookable elements of the event */
  lowestPrice?: Maybe<Scalars['Float']['output']>;
  /** Whether multiple operations of this event can be booked. */
  multiBookable?: Maybe<Scalars['Boolean']['output']>;
  /** Flag if the node itself has an online setting. */
  online: Scalars['Boolean']['output'];
  /** Online event settings. This field is only exposed if the user has a confirmed booking for the current node or one of its descendants. */
  onlineEventSettings?: Maybe<Array<OnlineEventSetting>>;
  /** A single operation by identifier. Any operation within the event including descendants can be requested. */
  operation?: Maybe<Operation>;
  /** The operations are the bookable items. Operations are not set for main events that have sub events. */
  operations?: Maybe<Array<Operation>>;
  /** The organizations defined as organizer */
  organizerOrganizations?: Maybe<Array<Organization>>;
  /** The users defined as organizer */
  organizerUsers?: Maybe<Array<GenericPerson>>;
  /** Flag if participant feature is generally enabled. */
  participantFeature?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Participants of this event. If the participant feature is not available, the field is null.
   *
   * todo: multiply by the limit somehow...
   */
  participants?: Maybe<ParticipantCollection>;
  /** Event payment settings */
  payment?: Maybe<PaymentSetting>;
  /** Flag if the event currently is promoted */
  promoted?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Related upcoming events based on tags
   * @deprecated Not supported anymore
   */
  relatedEvents?: Maybe<EventTeaserCollection>;
  /** A single speaker by identifier. Any speaker within the event can be requested. */
  speaker?: Maybe<Speaker>;
  /**
   * TODO: rename to speakers
   *
   * The speakers of the event
   */
  speakerCollection?: Maybe<SpeakerCollection>;
  /** Flag if speaker feature is enabled. If disabled, the speakers array is empty. */
  speakerFeature?: Maybe<Scalars['Boolean']['output']>;
  /** Earliest start date over all operation dates. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** A single sub-event by identifier. Any sub-event within the event can be requested. */
  subEvent?: Maybe<SubEvent>;
  /** The sub-events of the event. Only valid sub-events with operations are returned. */
  subEvents?: Maybe<Array<SubEvent>>;
  /** List of tags */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** The event's time zone */
  timezone: DateTimeZone;
  /** The title of the object */
  title: Scalars['String']['output'];
  /** The venue of this object. Further venues might be applied on other nodes within the event tree. */
  venue?: Maybe<Venue>;
  /**
   * Flag if comment feature is enabled and the viewer is eligible to view them. If commentFeature is true but viewerCommentFeature is disabled, the viewer needs to authenticate first.
   *
   * If the flag is disabled, the comments collection is always null.
   */
  viewerCommentFeature?: Maybe<Scalars['Boolean']['output']>;
  /** The authenticated invitee that belongs to the event */
  viewerInvitee?: Maybe<ViewerInvitee>;
  /** The authenticated participant that belongs to the event */
  viewerParticipant?: Maybe<ViewerParticipant>;
  /**
   * Flag if participant feature is enabled and the viewer is eligible to view them. If participantFeature is true but viewerParticipantFeature is disabled, the viewer needs to register to the event first.
   *
   * If the flag is disabled, the participants collection is always null.
   */
  viewerParticipantFeature?: Maybe<Scalars['Boolean']['output']>;
  /** The registration that is applied for the viewer. */
  viewerRegistration?: Maybe<Registration>;
};


/** An event object representation. An event is modelled as a node tree mainly consisting of events, operations and dates. */
export type EventAgendaItemArgs = {
  id: Scalars['ID']['input'];
};


/** An event object representation. An event is modelled as a node tree mainly consisting of events, operations and dates. */
export type EventCheckInsArgs = {
  limit?: InputMaybe<CollectionLimt>;
};


/** An event object representation. An event is modelled as a node tree mainly consisting of events, operations and dates. */
export type EventCommentsArgs = {
  limit?: InputMaybe<CollectionLimt>;
};


/** An event object representation. An event is modelled as a node tree mainly consisting of events, operations and dates. */
export type EventOperationArgs = {
  id: Scalars['ID']['input'];
};


/** An event object representation. An event is modelled as a node tree mainly consisting of events, operations and dates. */
export type EventOperationsArgs = {
  includeDescendants?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An event object representation. An event is modelled as a node tree mainly consisting of events, operations and dates. */
export type EventParticipantsArgs = {
  limit?: InputMaybe<CollectionLimt>;
};


/** An event object representation. An event is modelled as a node tree mainly consisting of events, operations and dates. */
export type EventRelatedEventsArgs = {
  limit?: InputMaybe<CollectionLimt>;
};


/** An event object representation. An event is modelled as a node tree mainly consisting of events, operations and dates. */
export type EventSpeakerArgs = {
  id: Scalars['ID']['input'];
};


/** An event object representation. An event is modelled as a node tree mainly consisting of events, operations and dates. */
export type EventSpeakerCollectionArgs = {
  limit?: InputMaybe<CollectionLimt>;
};


/** An event object representation. An event is modelled as a node tree mainly consisting of events, operations and dates. */
export type EventSubEventArgs = {
  id: Scalars['ID']['input'];
};

/**
 * An access object as a wrapper for accessible entities.
 *
 * This may be used for simple access solution applications. For more complex solutions with sub-gates, see the checkIn objects on Booking and BookingOperation types.
 */
export type EventAccess = {
  __typename?: 'EventAccess';
  /** Identification of the access. This has to match the number printed on the ticket (or other main identification). */
  accessIdentifier: Scalars['String']['output'];
  /** Booking reference number */
  bookingNr: Scalars['String']['output'];
  /** The actual check-in status */
  checkIn: CheckIn;
  /** Additional check-in information */
  checkInInfo: Scalars['String']['output'];
  /** The guest's first name. This is undefined if disabled in the admin check-in settings. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The guest's last name. This is undefined if disabled in the admin check-in settings. */
  lastName?: Maybe<Scalars['String']['output']>;
};

/** A EventAccess mutation response object */
export type EventAccessMutationOutput = MutationOutput & {
  __typename?: 'EventAccessMutationOutput';
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** The mutated EventAccess */
  object?: Maybe<EventAccess>;
};

/** Capacity definition for events */
export type EventCapacity = {
  __typename?: 'EventCapacity';
  /** Total available slots. The value is undefined if there is no limitation or the size is not exposed. */
  available?: Maybe<Scalars['Int']['output']>;
  /** Flag if it is generally bookable, even if the size is not exposed. */
  bookable: Scalars['Boolean']['output'];
  /** Total participants with active bookings */
  count: Scalars['Int']['output'];
  /** Maximum participants. The value is undefined if there is no limitation or the size is not exposed. */
  maximum?: Maybe<Scalars['Int']['output']>;
  /** Flag if there is a waitinglist */
  waitinglist: Scalars['Boolean']['output'];
};

/**
 * An access object as a wrapper for accessible entities.
 *
 * This may be used for simple access solution applications. For more complex solutions with sub-gates, see the checkIn objects on Booking and BookingOperation types.
 */
export type EventCheckIn = {
  __typename?: 'EventCheckIn';
  /** Identification of the access. This has to match the number printed on the ticket (or other main identification). */
  accessIdentifier: Scalars['String']['output'];
  /** The full name of the accompanied person. This is undefined if disabled in the admin check-in settings. */
  accompaniedPersonDisplayName?: Maybe<Scalars['String']['output']>;
  /** The first name of the accompanied person. This is undefined if disabled in the admin check-in settings. */
  accompaniedPersonFirstName?: Maybe<Scalars['String']['output']>;
  /** The last name of the accompanied person. This is undefined if disabled in the admin check-in settings. */
  accompaniedPersonLastName?: Maybe<Scalars['String']['output']>;
  /** Flag if the participant has attended */
  attendance: Scalars['Boolean']['output'];
  /** Date on which the attendance got registered by a check-in application. */
  attendanceDate?: Maybe<Scalars['DateTime']['output']>;
  /** Dates on which the attendance got registered by a check-in application. */
  attendanceDates: Array<Scalars['DateTime']['output']>;
  /** Uri for badge download */
  badgeUrl?: Maybe<Scalars['String']['output']>;
  /** Booking reference number */
  bookingNr: Scalars['String']['output'];
  /** Additional check-in information */
  checkInInfo: Scalars['String']['output'];
  /** Flag if the guest is a companion */
  companion: Scalars['Boolean']['output'];
  /** The companion id for which the check-in has been done */
  companionId?: Maybe<Scalars['ID']['output']>;
  /** The guest's full name. This is undefined if disabled in the admin check-in settings. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The guest's first name. This is undefined if disabled in the admin check-in settings. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** UUID of the object. Internally, this is the id of the BookingOperation. */
  id: Scalars['ID']['output'];
  /** The guest's last name. This is undefined if disabled in the admin check-in settings. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The operation id for which the check-in has been done */
  operationId: Scalars['ID']['output'];
  /** The participant id for which the check-in has been done */
  participantId: Scalars['ID']['output'];
  /** Flag if the guest is a representative */
  representative: Scalars['Boolean']['output'];
  /** The representative id for which the check-in has been done */
  representativeId?: Maybe<Scalars['ID']['output']>;
  /** The full name of the represented person. This is undefined if disabled in the admin check-in settings. */
  representedPersonDisplayName?: Maybe<Scalars['String']['output']>;
  /** The first name of the represented person. This is undefined if disabled in the admin check-in settings. */
  representedPersonFirstName?: Maybe<Scalars['String']['output']>;
  /** The last name of the represented person. This is undefined if disabled in the admin check-in settings. */
  representedPersonLastName?: Maybe<Scalars['String']['output']>;
};

/** EventCheckIn collection */
export type EventCheckInCollection = Collection & {
  __typename?: 'EventCheckInCollection';
  /** Number of returned items based on filter and limit */
  itemCount: Scalars['Int']['output'];
  /** The returned event checkin objects */
  items: Array<EventCheckIn>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
};

/** An EventCheckIn mutation response with a list of EventAccess mutation children. */
export type EventCheckInMutationOutput = MutationOutput & {
  __typename?: 'EventCheckInMutationOutput';
  /** The mutated children */
  accesses: Array<EventAccessMutationOutput>;
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** The mutated object */
  object?: Maybe<Event>;
};

/** Input type wrapper for the checkIn objects for an event check-in */
export type EventCheckInUpdateInput = {
  /** The new check-in status. */
  checkIns: Array<CheckInUpdateInput>;
};

/** An EventCheckIn mutation response with a list of EventAccess mutation children. */
export type EventCheckInUpdateMutationOutput = MutationOutput & {
  __typename?: 'EventCheckInUpdateMutationOutput';
  /** The mutated children */
  checkIns: Array<CheckInUpdateMutationOutput>;
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** The mutated object */
  object?: Maybe<Event>;
};

/** Event collection */
export type EventCollection = Collection & {
  __typename?: 'EventCollection';
  /** Number of returned items based on filter and limit */
  itemCount: Scalars['Int']['output'];
  /** The returned events */
  items: Array<Event>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
};

/** Input type to create a new Event */
export type EventCreateInput = {
  /** Categories of the event. */
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Deadline set as the registration end date. */
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  /** Event description exposed to the end-user. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Event type of the event. Basic settings are dependent from the event type. */
  eventTypeId: Scalars['ID']['input'];
  /** Event image. */
  image?: InputMaybe<Scalars['Resource']['input']>;
  /** Maximum participant limit for this event. */
  maxParticipant?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum participants limit for this event. */
  minParticipant?: InputMaybe<Scalars['Int']['input']>;
  /** Venue input creating a new venue object to assign to the event */
  newVenue?: InputMaybe<VenueCreateInput>;
  /** Online event setting for live online events */
  onlineEventSetting?: InputMaybe<ExternalOnlineEventSettingInput>;
  /** List of dates. At least one date should be set. */
  operationDates: Array<OperationDateCreateInput>;
  /** A remark for the back office. This is not exposed to the end-user. */
  remark?: InputMaybe<Scalars['String']['input']>;
  /** The main title of the event. */
  title: Scalars['String']['input'];
  /** Venue id to assign an existing venue */
  venueId?: InputMaybe<Scalars['ID']['input']>;
};

/** A Event mutation response object */
export type EventMutationOutput = MutationOutput & {
  __typename?: 'EventMutationOutput';
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** The mutated Event */
  object?: Maybe<Event>;
};

/** An event node interface */
export type EventNode = {
  /** The description of the object in HTML format */
  description?: Maybe<Scalars['String']['output']>;
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** Whether multiple operations of this event can be booked. */
  multiBookable?: Maybe<Scalars['Boolean']['output']>;
  /** The operations are the bookable items. Operations are not set for main events that have sub events. */
  operations?: Maybe<Array<Operation>>;
  /** The title of the object */
  title: Scalars['String']['output'];
  /** The venue of this object. Further venues might be applied on other nodes within the event tree. */
  venue?: Maybe<Venue>;
};

/** An event teaser consolidated with the most relevant information for more performant queries. */
export type EventTeaser = {
  __typename?: 'EventTeaser';
  /** Capacity information for the event */
  capacity: EventCapacity;
  /** Category teasers */
  categories: Array<CategoryTeaser>;
  /** The name of the event's currency */
  currencyName?: Maybe<Scalars['String']['output']>;
  /** Latest end date over all operation dates. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** UUID of the event type */
  eventTypeId: Scalars['ID']['output'];
  /** Key of the event type */
  eventTypeKey: Scalars['String']['output'];
  /** Name of the event type */
  eventTypeName: Scalars['String']['output'];
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** The main image of the object */
  image?: Maybe<Image>;
  /**
   * The main image of the object
   * @deprecated Use image
   */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Event key also used as partial url */
  key: Scalars['String']['output'];
  /**
   * The lead text of the object with a maximum length of 100 characters. If no lead text is specified, the cropped description in plain text is returned.
   * @deprecated Not supported anymore
   */
  lead: Scalars['String']['output'];
  /** The lowest price across all bookable elements of the event */
  lowestPrice?: Maybe<Scalars['Float']['output']>;
  /** Flag if the node itself has an online setting. */
  online: Scalars['Boolean']['output'];
  /** The operations are the bookable items. */
  operations: Array<OperationTeaser>;
  /** Flag if the event currently is promoted */
  promoted: Scalars['Boolean']['output'];
  /** Earliest start date over all operation dates. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** The event's time zone */
  timezone: DateTimeZone;
  /** The title of the object */
  title: Scalars['String']['output'];
  /** The venue of this object. Further venues might be applied on other nodes within the event tree. */
  venueName?: Maybe<Scalars['String']['output']>;
};

/** Event teaser collection */
export type EventTeaserCollection = Collection & {
  __typename?: 'EventTeaserCollection';
  /** Number of returned items based on filter and limit */
  itemCount: Scalars['Int']['output'];
  /** The returned events */
  items: Array<EventTeaser>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
};

/** Am event type object representation */
export type EventType = {
  __typename?: 'EventType';
  /** Flag if events of this type are shown in the app library */
  appLibrary: Scalars['Boolean']['output'];
  /** Authentication methods to see the event teasers for the standalone library. */
  authenticationMethods: Array<AuthenticationMethod>;
  /** Event type specific branding settings */
  branding?: Maybe<BrandingSetting>;
  /** Available categories. */
  categories?: Maybe<Array<Category>>;
  /** Single content section by identifier or key. */
  contentSection?: Maybe<ContentSection>;
  /**
   * Content sections for individual content pages.
   *
   * The content sections are only available if the viewer is authenticated by one of the event type's authentication methods.
   */
  contentSections?: Maybe<Array<ContentSection>>;
  /** Domain of the event type */
  domain: Scalars['String']['output'];
  /** Flag if event creation for this event type is enabled */
  eventCreation: Scalars['Boolean']['output'];
  /**
   * Event teaser collection with search and filter options.
   *
   * In case a search string is passed, the sorting is done by relevance. Otherwise it is sorted ascending by date.
   *
   * The collection is only available if the viewer is authenticated by one of the event type's authentication methods.
   */
  eventTeasers?: Maybe<EventTeaserCollection>;
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** The event type header image */
  image?: Maybe<Image>;
  /** Event type key also used as partial url to access the standalone library */
  key: Scalars['String']['output'];
  /** The event type name */
  name: Scalars['String']['output'];
  /** Flag if a standalone library for this event type is enabled. */
  standaloneLibrary: Scalars['Boolean']['output'];
  /**
   * Url to access the standalone library or the dedicated module directly. If the event type is not accessible
   *
   * directly at all, no url is returned.
   */
  url?: Maybe<Scalars['String']['output']>;
};


/** Am event type object representation */
export type EventTypeCategoriesArgs = {
  filter?: InputMaybe<EventTypeCategoriesFilter>;
};


/** Am event type object representation */
export type EventTypeContentSectionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};


/** Am event type object representation */
export type EventTypeEventTeasersArgs = {
  filter?: InputMaybe<EventTypeEventsFilter>;
  limit?: InputMaybe<CollectionLimt>;
};

/** Filter for event type categories */
export type EventTypeCategoriesFilter = {
  /** Flag to include only categories that are currently in use */
  filterActiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filter for events collection */
export type EventTypeEventsFilter = {
  /** Category UUIDs filter */
  filterCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Earliest start date filter */
  filterFromDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Flag to include only promoted events */
  filterPromotedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Latest end date filter */
  filterToDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Full-text search parameter */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Settings required to join an online event */
export type ExternalOnlineEventSetting = OnlineEventSetting & {
  __typename?: 'ExternalOnlineEventSetting';
  /** Additional description about the online meeting session. */
  description?: Maybe<Scalars['String']['output']>;
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** Timing of the online meeting */
  timing: OnlineEventTiming;
  /** Url to join the online meeting. This might be an internal handler which redirects to the external online session. */
  url: Scalars['String']['output'];
};

export type ExternalOnlineEventSettingInput = {
  /** Additional description about the online meeting session. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Url to the online meeting. */
  url: Scalars['String']['input'];
};

/** A file representation with resource object and meta data */
export type File = Asset & {
  __typename?: 'File';
  caption: Scalars['String']['output'];
  /** The file resource itself */
  resource?: Maybe<Scalars['Resource']['output']>;
  title: Scalars['String']['output'];
};

/** Input field value of asset objects */
export type FileInputFieldValue = InputFieldValue & {
  __typename?: 'FileInputFieldValue';
  /** The parsed value of type file */
  fileValue?: Maybe<File>;
  /** The input field for this value */
  inputField: InputField;
};

/** File upload form element */
export type FileUploadField = InputField & {
  __typename?: 'FileUploadField';
  /** The field identifier */
  identifier: Scalars['String']['output'];
  /** The field label. If not overwritten, the label is equal to the identifier. */
  label: Scalars['String']['output'];
  /** Flag stating the value as required. */
  required: Scalars['Boolean']['output'];
};

export enum FontSource {
  /** Client system font */
  Client = 'CLIENT',
  /** Font file provided */
  File = 'FILE',
  /** Google font */
  Google = 'GOOGLE'
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Unspecified = 'UNSPECIFIED'
}

/** A generic mutation response object with a simple success flag */
export type GenericMutationOutput = {
  __typename?: 'GenericMutationOutput';
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** Success flag of the mutation. True if message was sent. */
  success: Scalars['Boolean']['output'];
};

/** A limited participant object representation for a generic participant */
export type GenericParticipant = Participant & Person & {
  __typename?: 'GenericParticipant';
  displayName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** UUID of the object */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  /** The participant thumbnail image (portrait). As fallback, the user thumbnail image is set. */
  thumbnail?: Maybe<Image>;
  /** The user profile id of the participant if available */
  userId?: Maybe<Scalars['ID']['output']>;
};

/** A generic person representation */
export type GenericPerson = Person & {
  __typename?: 'GenericPerson';
  displayName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** UUID of the object */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  /** The participant thumbnail image (portrait). As fallback, the user thumbnail image is set. */
  thumbnail?: Maybe<Image>;
};

/** A limited user object representation for a generic user */
export type GenericUser = Person & User & {
  __typename?: 'GenericUser';
  displayName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** The user image (header) */
  image?: Maybe<Image>;
  lastName: Scalars['String']['output'];
  /** Events the user is organizer of */
  organizerEvents?: Maybe<EventTeaserCollection>;
  /** Events the user participates in */
  participantEvents?: Maybe<EventTeaserCollection>;
  /** The user thumbnail image (portrait) */
  thumbnail?: Maybe<Image>;
};


/** A limited user object representation for a generic user */
export type GenericUserOrganizerEventsArgs = {
  limit?: InputMaybe<CollectionLimt>;
};


/** A limited user object representation for a generic user */
export type GenericUserParticipantEventsArgs = {
  limit?: InputMaybe<CollectionLimt>;
};

export type GroupBooking = {
  __typename?: 'GroupBooking';
  /** Description of the group */
  description: Scalars['String']['output'];
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** All invited participants of the group. The field is only exposed to the primary participant. */
  invitedParticipants?: Maybe<Array<Participant>>;
  /** Name of the group */
  name: Scalars['String']['output'];
  /** Number of all active participants */
  participantCount: Scalars['Int']['output'];
  /** All participants of the group. The field is only exposed to the primary participant or the participant list feature is available. */
  participants?: Maybe<Array<Participant>>;
  /** The main participant (group owner) */
  primaryParticipant: Participant;
  /** Flag if others can join this group without being invited. */
  public: Scalars['Boolean']['output'];
};

/** Participant collection */
export type GroupBookingCollection = Collection & {
  __typename?: 'GroupBookingCollection';
  /** Number of returned items based on filter and limit */
  itemCount: Scalars['Int']['output'];
  /** The returned group bookings */
  items: Array<GroupBooking>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
};

/** Input type to create a new group booking */
export type GroupBookingCreateInput = {
  /** The group description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The group name */
  name: Scalars['String']['input'];
  /** Flag if the group can be joined by others */
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupBookingDefinition = {
  __typename?: 'GroupBookingDefinition';
  /** Group specific capacity definition. This object is undefined in case the operation size is not exposed. */
  groupCapacity?: Maybe<Capacity>;
  /** Maximum allowed participants for a group */
  maximumGroupParticipants?: Maybe<Scalars['Int']['output']>;
  /** Minimum required participants for a group */
  minimumGroupParticipants: Scalars['Int']['output'];
  /**
   * Limits and target of a new booking for the current viewer and operation.
   *
   * This is null in case the viewer is not eligible to book at all (i.e. Service user role)
   */
  viewerGroupBookable?: Maybe<Bookable>;
  /** Waitinglist settings if a waitinglist is configured for this group definition. */
  waitinglist?: Maybe<Waitinglist>;
};


export type GroupBookingDefinitionViewerGroupBookableArgs = {
  ignoreParticipantBookings?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A GroupBooking mutation response object */
export type GroupBookingMutationOutput = MutationOutput & {
  __typename?: 'GroupBookingMutationOutput';
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** The mutated GroupBooking */
  object?: Maybe<GroupBooking>;
};

export type GroupBookingParticipantAddInput = {
  /** UUID of the group booking */
  id: Scalars['ID']['input'];
  /** Username or email of the participant that is added to the group */
  participantUsernameOrEmail: Scalars['String']['input'];
};

export type GroupBookingParticipantRemoveInput = {
  /** UUID of the group booking */
  id: Scalars['ID']['input'];
  /** UUID of the participant to remove */
  participantId: Scalars['ID']['input'];
};

/** Input type for an update of a group booking object. Undefined attributes are not updated. */
export type GroupBookingUpdateInput = {
  /** The new description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the group booking to be updated */
  id: Scalars['ID']['input'];
  /** The new public flag value */
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An image object representation */
export type Image = Asset & {
  __typename?: 'Image';
  caption: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  /** A requested thumbnail of the actual image. In contrast to the File type, the original image is never exposed. */
  thumbnail?: Maybe<Thumbnail>;
  title: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};


/** An image object representation */
export type ImageThumbnailArgs = {
  format?: InputMaybe<ImageFormat>;
  height?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum ImageFormat {
  /** AV1 Image File Format */
  Avif = 'AVIF',
  /** Bitmap format */
  Bmp = 'BMP',
  /** Graphics Interchange Format */
  Gif = 'GIF',
  /** Alternative extension for JPG */
  Jpeg = 'JPEG',
  /** Joint Photographic Experts Group format */
  Jpg = 'JPG',
  /** Portable Network Graphics */
  Png = 'PNG',
  /** Wireless Bitmap */
  Wbmp = 'WBMP',
  /** WebP format */
  Webp = 'WEBP',
  /** X Bitmap */
  Xbm = 'XBM'
}

/** Input field value of image asset objects */
export type ImageInputFieldValue = InputFieldValue & {
  __typename?: 'ImageInputFieldValue';
  /** The parsed value of type file */
  imageValue?: Maybe<Image>;
  /** The input field for this value */
  inputField: InputField;
};

/** Image upload form element */
export type ImageUploadField = InputField & {
  __typename?: 'ImageUploadField';
  /** The field identifier */
  identifier: Scalars['String']['output'];
  /** The field label. If not overwritten, the label is equal to the identifier. */
  label: Scalars['String']['output'];
  /** Flag stating the value as required. */
  required: Scalars['Boolean']['output'];
};

/** An input field interface */
export type InputField = {
  /** The field identifier */
  identifier: Scalars['String']['output'];
  /** The field label. If not overwritten, the label is equal to the identifier. */
  label: Scalars['String']['output'];
};

/** Validators for input form elements. Input values are validated against those validators in the backend. */
export enum InputFieldValidator {
  /** Alphanumeric value required */
  Alphanumeric = 'ALPHANUMERIC',
  /** Email address required */
  EmailAddress = 'EMAIL_ADDRESS',
  /** Float value required */
  Float = 'FLOAT',
  /** Integer value required */
  Integer = 'INTEGER'
}

/** An input field value interface */
export type InputFieldValue = {
  /** The input field for this value */
  inputField: InputField;
};

/** Input type for an input field value */
export type InputFieldValueInput = {
  /** The field identifier */
  identifier: Scalars['String']['input'];
  /**
   * The input value as string. The following values are expected depending on the input field:
   *
   * - UNIX timestamp for DatePickerField
   *
   * - Base64 encoded content for FileUploadField and ImageUploadField
   *
   * - 1/0, true/false, or others for CheckboxField
   *
   * - Array of strings for MultiSelectCheckboxesField
   *
   * - Any string for all other fields
   *
   * If no value (null) is given, the value is not updated. If an empty string is given, the value is removed.
   */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Settings required to join an online event */
export type InternalOnlineEventSetting = OnlineEventSetting & {
  __typename?: 'InternalOnlineEventSetting';
  /** Additional description about the online meeting session. */
  description?: Maybe<Scalars['String']['output']>;
  /** Optional file extension for a live stream */
  fileExtension?: Maybe<Scalars['String']['output']>;
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** Timing of the online meeting */
  timing: OnlineEventTiming;
  /** Url to join the online meeting. This might be an internal handler which redirects to the external online session. */
  url: Scalars['String']['output'];
};

/** An invitee operation object representation */
export type InviteeOperation = {
  __typename?: 'InviteeOperation';
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** The market price of the invitation */
  marketPrice?: Maybe<Scalars['Float']['output']>;
  /** Operation dates */
  operationDates: Array<OperationDate>;
  /** Price breakdown. This explanation is stated for compliance purposes. */
  priceBreakdown: Scalars['String']['output'];
  /** The title of the object */
  title: Scalars['String']['output'];
  /** The venue of this object */
  venue?: Maybe<Venue>;
};

/** Invitee status */
export enum InviteeStatus {
  /** Invitee has accepted the invitation */
  Accepted = 'ACCEPTED',
  /** Accepted invitation is confirmed by the back-office */
  Confirmed = 'CONFIRMED',
  /** Invitee with an open invitation */
  Invited = 'INVITED',
  /** Invitee has rejected the invitation */
  Rejected = 'REJECTED'
}

export enum Layout {
  Default = 'DEFAULT',
  Wide = 'WIDE'
}

/** Locale language settings */
export type Language = {
  __typename?: 'Language';
  /** List of available language identifiers. */
  available: Array<Scalars['String']['output']>;
  /** Default language identifier. */
  default: Scalars['String']['output'];
};

/** Input field value of type list string. The value is a json decoded list to the input string . */
export type ListStringInputFieldValue = InputFieldValue & {
  __typename?: 'ListStringInputFieldValue';
  /** The input field for this value */
  inputField: InputField;
  /** The value parsed as a list of string values. */
  stringValues: Array<Scalars['String']['output']>;
};

/** Input type for sending a message */
export type MessageInput = {
  /** UUID of the corresponding recipient type */
  recipientId?: InputMaybe<Scalars['ID']['input']>;
  /** Recipient type */
  recipientType: RecipientType;
  /** Message text */
  text: Scalars['String']['input'];
};

/** Input type for a sender of a message */
export type MessageSenderInput = {
  captcha: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

/** Single line text (textarea form element) */
export type MultiLineTextField = InputField & {
  __typename?: 'MultiLineTextField';
  /** Default value as preset for the control. */
  defaultValue: Scalars['String']['output'];
  /** The field identifier */
  identifier: Scalars['String']['output'];
  /** The field label. If not overwritten, the label is equal to the identifier. */
  label: Scalars['String']['output'];
  /** Placeholder value for the control. */
  placeholder: Scalars['String']['output'];
  /** Flag stating the value as required. */
  required: Scalars['Boolean']['output'];
  /** Validator type the value is validated against in the backend. */
  validator?: Maybe<InputFieldValidator>;
};

/** Checkbox group form elements */
export type MultiSelectCheckboxesField = InputField & {
  __typename?: 'MultiSelectCheckboxesField';
  /** The field identifier */
  identifier: Scalars['String']['output'];
  /** The field label. If not overwritten, the label is equal to the identifier. */
  label: Scalars['String']['output'];
  /** Available options of the control */
  options: Array<SelectFieldOption>;
  /** Flag stating the value as required. */
  required: Scalars['Boolean']['output'];
};

/** Mutations for the Zoon Repository */
export type Mutation = {
  __typename?: 'Mutation';
  /** Authentication methods */
  authentication: Authentication;
  /** User context representation analog to the viewer concept of the queries. */
  viewer?: Maybe<MutationViewer>;
};


/** Mutations for the Zoon Repository */
export type MutationViewerArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** A wrapper for all event mutations */
export type MutationEvent = {
  __typename?: 'MutationEvent';
  /** Create a new booking. The booking status will be reserved after creation. */
  createBooking?: Maybe<BookingMutationOutput>;
  /** Create a new cancellation. */
  createCancellation?: Maybe<CancellationMutationOutput>;
  /** Create a new comment. An authenticated user or participant is required. */
  createComment?: Maybe<CommentMutationOutput>;
  /** Delete an existing deletable comment. */
  deleteComment?: Maybe<CommentMutationOutput>;
  /** Resend the booking confirmation message by an email address. The response is successful even if the participant is not existing. */
  resendBookingConfirmationByParticipantEmail: GenericMutationOutput;
  /** Send an email message in the context of an event. */
  sendEmailMessage?: Maybe<GenericMutationOutput>;
  /** Update the check-in status of check-in objects of the event. Error returned if no check-in is active. */
  updateCheckIns?: Maybe<EventCheckInUpdateMutationOutput>;
  /** The authenticated invitee that belongs to the event */
  viewerInvitee?: Maybe<MutationViewerInvitee>;
  /** The authenticated participant that belongs to the event */
  viewerParticipant?: Maybe<MutationViewerParticipant>;
};


/** A wrapper for all event mutations */
export type MutationEventCreateBookingArgs = {
  booking: BookingCreateInput;
};


/** A wrapper for all event mutations */
export type MutationEventCreateCancellationArgs = {
  cancellation: CancellationCreateInput;
};


/** A wrapper for all event mutations */
export type MutationEventCreateCommentArgs = {
  comment: CommentCreateInput;
};


/** A wrapper for all event mutations */
export type MutationEventDeleteCommentArgs = {
  id: Scalars['ID']['input'];
};


/** A wrapper for all event mutations */
export type MutationEventResendBookingConfirmationByParticipantEmailArgs = {
  email: Scalars['String']['input'];
};


/** A wrapper for all event mutations */
export type MutationEventSendEmailMessageArgs = {
  message: MessageInput;
  sender?: InputMaybe<MessageSenderInput>;
};


/** A wrapper for all event mutations */
export type MutationEventUpdateCheckInsArgs = {
  event: EventCheckInUpdateInput;
};

/** A mutation response object */
export type MutationOutput = {
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** The mutated object */
  object?: Maybe<MutationOutputObject>;
};

export type MutationOutputObject = Booking | BookingOperation | Cancellation | Comment | Event | EventAccess | EventCheckIn | GroupBooking | ViewerInvitee | ViewerParticipant | ViewerUser;

/** A wrapper for all user registration mutations */
export type MutationUser = {
  __typename?: 'MutationUser';
  /**
   * Create a new user. A created user has to be accepted in the admin portal. After being accepted, the user gets a confirmation mail with a password reset url.
   *
   * In case an existing username or email is used the response is still sucessful.
   *
   * In case the create user feature is disabled, the response is null
   */
  createUser?: Maybe<GenericMutationOutput>;
  /** Request a password reset url. The response is always successful, even if the username or email is not available. */
  requestPasswordReset: GenericMutationOutput;
  /** Reset the user password */
  resetPassword: ViewerUserMutationOutput;
};


/** A wrapper for all user registration mutations */
export type MutationUserCreateUserArgs = {
  user: UserCreateInput;
};


/** A wrapper for all user registration mutations */
export type MutationUserRequestPasswordResetArgs = {
  user: UserInput;
};


/** A wrapper for all user registration mutations */
export type MutationUserResetPasswordArgs = {
  password: PasswordResetInput;
};

/** A viewer context representation for mutations */
export type MutationViewer = {
  __typename?: 'MutationViewer';
  /** Create a new event. The event is created as draft and is not yet accessible through the API after creation. */
  createEvent?: Maybe<EventMutationOutput>;
  /** Single event by identifier */
  event?: Maybe<MutationEvent>;
  /** Send a global email message. */
  sendEmailMessage?: Maybe<GenericMutationOutput>;
  /** Update the authenticated viewer user */
  updateUser?: Maybe<ViewerUserMutationOutput>;
  /** User registration and management */
  user?: Maybe<MutationUser>;
};


/** A viewer context representation for mutations */
export type MutationViewerCreateEventArgs = {
  event: EventCreateInput;
};


/** A viewer context representation for mutations */
export type MutationViewerEventArgs = {
  id: Scalars['ID']['input'];
};


/** A viewer context representation for mutations */
export type MutationViewerSendEmailMessageArgs = {
  message: MessageInput;
  sender?: InputMaybe<MessageSenderInput>;
};


/** A viewer context representation for mutations */
export type MutationViewerUpdateUserArgs = {
  user: UserUpdateInput;
};

export type MutationViewerInvitee = {
  __typename?: 'MutationViewerInvitee';
  /** Confirm a reserved booking after it got created. */
  accept: ViewerInviteeMutationOutput;
  /** Cancel a reserved booking after it got created. */
  reject: ViewerInviteeMutationOutput;
};

export type MutationViewerParticipant = {
  __typename?: 'MutationViewerParticipant';
  addGroupBookingParticipant: GroupBookingMutationOutput;
  /** Cancel a reserved booking after it got created. */
  cancelBooking: BookingMutationOutput;
  /** Participant check-in for a specific online event */
  checkInByOnlineEventSetting: ViewerParticipantMutationOutput;
  /** Confirm a reserved booking after it got created. */
  confirmBooking: BookingMutationOutput;
  /** Confirm invitations from the waitinglist. The Booking operations should have status invited. */
  confirmBookingOperations: BookingOperationsMutationOutput;
  /** Delete a confirmed booking. */
  deleteBooking: BookingMutationOutput;
  /**
   * Update the status of booking operations to delete.
   *
   * The purpose may be to decline invitations or simply to remove booking operations from a booking.
   */
  deleteBookingOperations: BookingOperationsMutationOutput;
  /** Update the group booking */
  removeGroupBookingParticipant: GroupBookingMutationOutput;
  /** Resend the booking confirmation message for a previously confirmed booking. */
  resendBookingConfirmation: BookingMutationOutput;
  /** Update the booking operations of an existing booking */
  updateBooking: BookingMutationOutput;
  /** Update the group booking */
  updateGroupBooking?: Maybe<GroupBookingMutationOutput>;
  /** Update the viewer participant */
  updateParticipant: ViewerParticipantMutationOutput;
};


export type MutationViewerParticipantAddGroupBookingParticipantArgs = {
  groupBookingParticipant: GroupBookingParticipantAddInput;
};


export type MutationViewerParticipantCancelBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationViewerParticipantCheckInByOnlineEventSettingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationViewerParticipantConfirmBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationViewerParticipantConfirmBookingOperationsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationViewerParticipantDeleteBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationViewerParticipantDeleteBookingOperationsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationViewerParticipantRemoveGroupBookingParticipantArgs = {
  groupBookingParticipant: GroupBookingParticipantRemoveInput;
};


export type MutationViewerParticipantResendBookingConfirmationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationViewerParticipantUpdateBookingArgs = {
  booking: BookingUpdateInput;
};


export type MutationViewerParticipantUpdateGroupBookingArgs = {
  groupBooking: GroupBookingUpdateInput;
};


export type MutationViewerParticipantUpdateParticipantArgs = {
  participant: ParticipantUpdateInput;
};

/** Online event setting interface */
export type OnlineEventSetting = {
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** Timing of the online meeting */
  timing: OnlineEventTiming;
  /** Url to join the online meeting. This might be an internal handler which redirects to the external online session. */
  url: Scalars['String']['output'];
};

export enum OnlineEventTiming {
  /** Live online event Timing */
  Live = 'LIVE',
  /** Replay online event Timing */
  Replay = 'REPLAY'
}

/** An operation object representation */
export type Operation = {
  __typename?: 'Operation';
  /** A booking of this operation can be cancelled by the viewer. */
  bookingDeletable: Scalars['Boolean']['output'];
  /** Capacity definition of the operation. This object is undefined in case the operation size is not exposed. */
  capacity?: Maybe<Capacity>;
  /** Operation specific deadline. If no specific deadline is set, the registration end date is returned. */
  deadline?: Maybe<Scalars['DateTime']['output']>;
  /** The description of the object in HTML format */
  description: Scalars['String']['output'];
  /** Group booking definition specified if the group booking option is enabled for the operation. */
  groupBookingDefinition?: Maybe<GroupBookingDefinition>;
  /** Group bookings of this operation. This is null if no group booking definition is available */
  groupBookings?: Maybe<GroupBookingCollection>;
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** Fields to be prompted to the viewer while booking this operation. */
  inputFields: Array<InputField>;
  /** The market price of the operation. This price is stated for compliance purposes. */
  marketPrice?: Maybe<Scalars['Float']['output']>;
  /** Flag if the node itself has an online setting. */
  online: Scalars['Boolean']['output'];
  /** Online event settings. This field is only exposed if the user has a confirmed booking for the current node or one of its descendants. */
  onlineEventSettings: Array<OnlineEventSetting>;
  /** Operation dates */
  operationDates: Array<OperationDate>;
  /** Parent event or sub-event id */
  parentId: Scalars['ID']['output'];
  /** The actual price of the operation that is calculated in the booking. */
  price?: Maybe<Scalars['Float']['output']>;
  /** Price breakdown. This explanation is stated for compliance purposes. */
  priceBreakdown: Scalars['String']['output'];
  /** The title of the object */
  title: Scalars['String']['output'];
  /** Counts of total bookings for this operation. */
  totalBookingCounts: BookingAggregation;
  /** The venue of this object. Further venues might be applied on other nodes within the event tree. */
  venue?: Maybe<Venue>;
  /**
   * Limits and target of a new booking for the current viewer and operation.
   *
   * This is null in case the viewer is not eligible to book at all (i.e. Service user role)
   */
  viewerBookable?: Maybe<Bookable>;
  /** Counts of the viewer's bookings for this operation. */
  viewerBookingCounts?: Maybe<BookingAggregation>;
  /** Waitinglist settings if a waitinglist is configured for this operation. */
  waitinglist?: Maybe<Waitinglist>;
};


/** An operation object representation */
export type OperationGroupBookingsArgs = {
  limit?: InputMaybe<CollectionLimt>;
};


/** An operation object representation */
export type OperationViewerBookableArgs = {
  ignoreParticipantBookings?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A date object representation */
export type OperationDate = {
  __typename?: 'OperationDate';
  endDate: Scalars['DateTime']['output'];
  /** UUID of the object */
  id: Scalars['ID']['output'];
  startDate: Scalars['DateTime']['output'];
  venue?: Maybe<Venue>;
};

/** Input type to create a new operation date */
export type OperationDateCreateInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

/** An date teaser consolidated with the most relevant information for more performant queries. */
export type OperationDateTeaser = {
  __typename?: 'OperationDateTeaser';
  endDate: Scalars['DateTime']['output'];
  startDate: Scalars['DateTime']['output'];
  /**
   * The venue of this specific date
   * @deprecated No longer supported
   */
  venueName?: Maybe<Scalars['String']['output']>;
};

/** An operation teaser consolidated with the most relevant information for more performant queries. */
export type OperationTeaser = {
  __typename?: 'OperationTeaser';
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** Flag if the node itself has an online setting. */
  online: Scalars['Boolean']['output'];
  /** Operation dates */
  operationDates: Array<OperationDateTeaser>;
  /** The title of the object */
  title: Scalars['String']['output'];
  /**
   * The venue of this specific operation
   * @deprecated No longer supported
   */
  venueName?: Maybe<Scalars['String']['output']>;
};

/** An organization object representation */
export type Organization = {
  __typename?: 'Organization';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  name: Scalars['String']['output'];
};

export type Participant = {
  displayName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** UUID of the object */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  /** The participant thumbnail image (portrait). As fallback, the user thumbnail image is set. */
  thumbnail?: Maybe<Image>;
  /** The user profile of the participant if available */
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Person collection */
export type ParticipantCollection = Collection & {
  __typename?: 'ParticipantCollection';
  /** Number of returned items based on filter and limit */
  itemCount: Scalars['Int']['output'];
  /** The returned participants */
  items: Array<GenericParticipant>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
};

/** Input type to create or update a participant object of a cancellation */
export type ParticipantCreateInput = {
  /** Input field values according to the participant definition */
  inputFieldValues: Array<InputFieldValueInput>;
};

/** A participant definition object representation containing configuration properties for the booking's participant. */
export type ParticipantDefinition = {
  __typename?: 'ParticipantDefinition';
  /** Flag whether the participant can create a cancellation or not. */
  cancellation: Scalars['Boolean']['output'];
  /** Fields to be prompted to the viewer while cancelling to ask about information about the participant. */
  cancellationInputFields: Array<InputField>;
  /** Fields to be prompted to the viewer while booking to ask about information about the companion. */
  companionInputFields: Array<InputField>;
  /** Allow companions. */
  companions: Scalars['Boolean']['output'];
  /** Fields to be prompted to the viewer while booking to ask about information about the participant. */
  inputFields: Array<InputField>;
  /** Number of possible companions. 0 if disabled. Null if unlimited. */
  maximumCompanions?: Maybe<Scalars['Int']['output']>;
  /** Setting to request specific opt-in during the registration process to set the participant's public flag. */
  publicParticipantOptIn: ParticipantFeatureSetting;
  /** Allow a companion as a participant representative. This does not count towards the maxCompanions limit. */
  representative: Scalars['Boolean']['output'];
};

/** Participant feature setting options to decide who has access to the participants */
export enum ParticipantFeatureSetting {
  /** Disabled participant feature */
  Disabled = 'DISABLED',
  /** Participants are accessible for everyone */
  Everyone = 'EVERYONE',
  /** Participants are only accessible for other participants with active bookings */
  Participant = 'PARTICIPANT'
}

/** Participant status */
export enum ParticipantStatus {
  /** A participant who has accessed the event page but wihout any confirmed bookings */
  Accessed = 'ACCESSED',
  /** Status of a participant who has attended the event */
  Attendance = 'ATTENDANCE',
  /** Status of a participant with cancellation. */
  Cancellation = 'CANCELLATION',
  /** A potential participant without any response */
  NoResponse = 'NO_RESPONSE',
  /** Status of a participant with confirmed bookings and confirmed booking operations. */
  Registration = 'REGISTRATION',
  /** Status of a participant with confirmed bookings containing only waiting or invited booking operations. */
  Waitinglist = 'WAITINGLIST'
}

/** Input type for an update of a participant object */
export type ParticipantUpdateInput = {
  /** Input field values according to the participant definition */
  inputFieldValues: Array<InputFieldValueInput>;
  /** Flag if the participant is shown in the participant list */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Representative for this participant.
   *
   * If the input id is matching the existing representative, the representative gets updated
   */
  representative?: InputMaybe<CompanionCreateInput>;
};

/** Input type to reset a user password */
export type PasswordResetInput = {
  /** New password (At least 8 characters containing lower-and uppercase letters, numbers and special characters.) */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The token to identify the user */
  token?: InputMaybe<Scalars['String']['input']>;
};

/** A payment object representation */
export type Payment = {
  __typename?: 'Payment';
  /** Handling fee according to the booking's `includingVat` flag */
  commissionPrice: Scalars['Float']['output'];
  /** The applied handling fee rate */
  commissionRate: Scalars['Float']['output'];
  /** The VAT amount applied on the handling fee */
  commissionVatPrice: Scalars['Float']['output'];
  /** The payment type */
  currency: Currency;
  /**
   * The URI to initiate the payment through a payment gateway.
   *
   * If there is no online payment for this booking (cf. field `onlinePaymentRequired`), the field returns null.
   */
  gatewayUri?: Maybe<Scalars['String']['output']>;
  /** Flag if online payment is required through payment gateway. */
  onlinePaymentRequired: Scalars['Boolean']['output'];
  /** The payment type */
  paymentStatus: PaymentStatus;
  /** The payment type */
  paymentType: PaymentType;
  /** Sub total price according to the booking's `includingVat` flag */
  subTotalPrice: Scalars['Float']['output'];
  /** Total price according to the booking's `includingVat` flag */
  totalPrice: Scalars['Float']['output'];
  /** The effective final price. Total price including VAT rounded according to the currency. */
  totalPriceInclVatRounded: Scalars['Float']['output'];
  /** The total VAT amount applied on the total price */
  totalVatPrice: Scalars['Float']['output'];
  /** The overall applied VAT rate taken from the event payment settings. */
  vatRate: Scalars['Float']['output'];
};


/** A payment object representation */
export type PaymentGatewayUriArgs = {
  cancelCallbackUri: Scalars['String']['input'];
  failCallbackUri: Scalars['String']['input'];
  successCallbackUri: Scalars['String']['input'];
};

/** Event payment settings */
export type PaymentSetting = {
  __typename?: 'PaymentSetting';
  /** The currency */
  currency: Currency;
  /** The payment type */
  paymentType: PaymentType;
};

/** Payment status */
export enum PaymentStatus {
  /** Payment is done completely. */
  Complete = 'COMPLETE',
  /** Payment is not yet done. */
  Open = 'OPEN',
  /** Payment is made partially. There is still an outstanding amount. */
  Partial = 'PARTIAL'
}

/** A payment type object representation */
export type PaymentType = {
  __typename?: 'PaymentType';
  /** Indicating if there is a payment gateway connected to the type. */
  gateway: Scalars['Boolean']['output'];
  /** The payment type name */
  name: Scalars['String']['output'];
};

export type Person = {
  displayName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** UUID of the object */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  /** The user thumbnail image (portrait) */
  thumbnail?: Maybe<Image>;
};

/** Mutations for the Zoon Repository */
export type Query = {
  __typename?: 'Query';
  /** Global app configuration settings. */
  app: App;
  /**
   * User context representation implemented according to the viewer concept (cf. https://medium.com/the-graphqlhub/graphql-and-authentication-b73aed34bbeb).
   *
   * Viewer sub-nodes are dependent from the viewer object itself.
   */
  viewer?: Maybe<Viewer>;
};


/** Mutations for the Zoon Repository */
export type QueryViewerArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** Recipient type when sending messages */
export enum RecipientType {
  Event = 'EVENT',
  EventType = 'EVENT_TYPE',
  Global = 'GLOBAL',
  Organization = 'ORGANIZATION',
  User = 'USER'
}

/** A registration object representation containing configuration properties for bookings. */
export type Registration = {
  __typename?: 'Registration';
  /**
   * Flag whether the participant can create a cancellation or not.
   * @deprecated Use flag on ParticipantDefinition
   */
  cancellation: Scalars['Boolean']['output'];
  /** Fixed discount amount that is applied on the booking. */
  discountAmount: Scalars['Float']['output'];
  /** Discount percentage that is applied on the booking price. */
  discountPercentage: Scalars['Float']['output'];
  /** Fields to be prompted to the viewer while booking to ask about information about the booking. */
  inputFields: Array<InputField>;
  /** Name of the registration for information only. It might be something like 'Early Bird' */
  name: Scalars['String']['output'];
  /** Note for the participant regarding specific booking conditions, rules or general advice related to the booking process. */
  note: Scalars['String']['output'];
  /** Participant definition of this registration. */
  participantDefinition: ParticipantDefinition;
  /** Registration attachments that are required to be accepted by the participant. */
  participantRequirements: Array<RegistrationAttachment>;
  /** Fix price applied on the booking. */
  price: Scalars['Float']['output'];
  /** Flag indicating if the registration currently is running. */
  running: Scalars['Boolean']['output'];
};

/** A registration attachment object representation. Depending on the context, the attachment may be a requirement (terms & conditions) as well as general information */
export type RegistrationAttachment = {
  __typename?: 'RegistrationAttachment';
  /** The attachment file */
  file?: Maybe<File>;
  /** The name or title */
  name: Scalars['String']['output'];
  /** The text explaining the content */
  text: Scalars['String']['output'];
};

/** Option value of a select field */
export type SelectFieldOption = {
  __typename?: 'SelectFieldOption';
  label: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

/** Single line text (input form element) */
export type SingleLineTextField = InputField & {
  __typename?: 'SingleLineTextField';
  /** Default value as preset for the control. */
  defaultValue: Scalars['String']['output'];
  /** The field identifier */
  identifier: Scalars['String']['output'];
  /** The field label. If not overwritten, the label is equal to the identifier. */
  label: Scalars['String']['output'];
  /** Placeholder value for the control. */
  placeholder: Scalars['String']['output'];
  /** Flag stating the value as required. */
  required: Scalars['Boolean']['output'];
  /** Validator type the value is validated against in the backend. */
  validator?: Maybe<InputFieldValidator>;
};

/** Single select form element (dropdown) */
export type SingleSelectDropdownField = InputField & {
  __typename?: 'SingleSelectDropdownField';
  /** The field identifier */
  identifier: Scalars['String']['output'];
  /** The field label. If not overwritten, the label is equal to the identifier. */
  label: Scalars['String']['output'];
  /** Available options of the control */
  options: Array<SelectFieldOption>;
  /** Flag stating the value as required. */
  required: Scalars['Boolean']['output'];
};

/** Single select form element (radio) */
export type SingleSelectRadiobuttonsField = InputField & {
  __typename?: 'SingleSelectRadiobuttonsField';
  /** The field identifier */
  identifier: Scalars['String']['output'];
  /** The field label. If not overwritten, the label is equal to the identifier. */
  label: Scalars['String']['output'];
  /** Available options of the control */
  options: Array<SelectFieldOption>;
  /** Flag stating the value as required. */
  required: Scalars['Boolean']['output'];
};

export enum SocialMediaPlatform {
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  X = 'X'
}

/** A speaker object representation */
export type Speaker = Person & {
  __typename?: 'Speaker';
  /** Short biography of the speaker */
  bio: Scalars['String']['output'];
  /** Full name of the speaker */
  displayName: Scalars['String']['output'];
  /** First name of the speaker */
  firstName: Scalars['String']['output'];
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** The job title or position of the speaker */
  jobTitle: Scalars['String']['output'];
  /** Last name of the speaker */
  lastName: Scalars['String']['output'];
  /** Organization of the speaker */
  organization: Scalars['String']['output'];
  /** Links to social media platforms of the speaker */
  socialMedia: Array<AdditionalSocialMediaField>;
  /** The participant thumbnail image (portrait). As fallback, the user thumbnail image is set. */
  thumbnail?: Maybe<Image>;
};

/** Speaker collection */
export type SpeakerCollection = Collection & {
  __typename?: 'SpeakerCollection';
  /** Number of returned items based on filter and limit */
  itemCount: Scalars['Int']['output'];
  /** The returned speakers */
  items: Array<Speaker>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
};

/** Static text. This is not a real form element. */
export type StaticTextField = InputField & {
  __typename?: 'StaticTextField';
  /** The field identifier */
  identifier: Scalars['String']['output'];
  /** The field label. If not overwritten, the label is equal to the identifier. */
  label: Scalars['String']['output'];
  /** The static text to be rendered. */
  text: Scalars['String']['output'];
};

/** Input field value of type string. The value is equal to the input. */
export type StringInputFieldValue = InputFieldValue & {
  __typename?: 'StringInputFieldValue';
  /** The input field for this value */
  inputField: InputField;
  /** The string input value as submitted */
  stringValue: Scalars['String']['output'];
};

/** A sub event object representation */
export type SubEvent = EventNode & {
  __typename?: 'SubEvent';
  /** The description of the object in HTML format */
  description: Scalars['String']['output'];
  /** Latest end date over all operation dates. */
  endDate: Scalars['DateTime']['output'];
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** Whether multiple operations of this sub-event can be booked. */
  multiBookable: Scalars['Boolean']['output'];
  /** Flag if the node itself has an online setting. */
  online: Scalars['Boolean']['output'];
  /** Online event settings. This field is only exposed if the user has a confirmed booking for the current node or one of its descendants. */
  onlineEventSettings: Array<OnlineEventSetting>;
  /** The operations are the bookable items. Operations are not set for main events that have sub events. */
  operations: Array<Operation>;
  /** Earliest start date over all operation dates. */
  startDate: Scalars['DateTime']['output'];
  /** The title of the object */
  title: Scalars['String']['output'];
  /** The venue of this object. Further venues might be applied on other nodes within the event tree. */
  venue?: Maybe<Venue>;
};

/** A thumbnail representing the scaled image resources with configuration properties. */
export type Thumbnail = {
  __typename?: 'Thumbnail';
  /** The format of the generated thumbnail */
  format?: Maybe<ImageFormat>;
  /** The height of the generated thumbnail */
  height?: Maybe<Scalars['Int']['output']>;
  /** The quality of the generated thumbnail (between 0 - very poor and 100 - very good) */
  quality?: Maybe<Scalars['Int']['output']>;
  /** The actual image source uri */
  resource?: Maybe<Scalars['Resource']['output']>;
  /** The width of the generated thumbnail */
  width?: Maybe<Scalars['Int']['output']>;
};

/** Input type for access code */
export type TokenCreateByAccessCodeInput = {
  accessCode: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
};

/** Input type for token creation by app token */
export type TokenCreateByAppTokenInput = {
  key: Scalars['String']['input'];
};

/** Input type for token creation by event token */
export type TokenCreateByEventTokenInput = {
  eventId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
};

/** Input type for token creation by participant */
export type TokenCreateByParticipantInput = {
  accessIdentifier: Scalars['String']['input'];
};

/** Input type for username and password */
export type TokenCreateByUsernamePasswordInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Created access token response */
export type TokenMutationOutput = {
  __typename?: 'TokenMutationOutput';
  token: Scalars['String']['output'];
};

export type User = {
  displayName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** The user image (header) */
  image?: Maybe<Image>;
  lastName: Scalars['String']['output'];
  /** Events the user is organizer of */
  organizerEvents?: Maybe<EventTeaserCollection>;
  /** Events the user participates in */
  participantEvents?: Maybe<EventTeaserCollection>;
  /** The user thumbnail image (portrait) */
  thumbnail?: Maybe<Image>;
};


export type UserOrganizerEventsArgs = {
  limit?: InputMaybe<CollectionLimt>;
};


export type UserParticipantEventsArgs = {
  limit?: InputMaybe<CollectionLimt>;
};

/** Input type for an new user object. */
export type UserCreateInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  image?: InputMaybe<Scalars['Resource']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['Resource']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Input type to identify a user */
export type UserInput = {
  usernameOrEmail: Scalars['String']['input'];
};

/** Input type for an update of a user object. Undefined attributes are not updated. */
export type UserUpdateInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  image?: InputMaybe<Scalars['Resource']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** New password (At least 8 characters containing lower-and uppercase letters, numbers and special characters.) */
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['Resource']['input']>;
};

/** A venue object representation */
export type Venue = {
  __typename?: 'Venue';
  /** The country of the venue */
  country: Scalars['String']['output'];
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** GEO latitude coordinate */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** GEO longitude coordinate */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The name including address */
  name: Scalars['String']['output'];
  /** The state/canton of the venue */
  state: Scalars['String']['output'];
};

/** Venue collection */
export type VenueCollection = Collection & {
  __typename?: 'VenueCollection';
  /** Number of returned items based on filter and limit */
  itemCount: Scalars['Int']['output'];
  /** The returned venues */
  items: Array<Venue>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
};

/** Input type to create a new venue */
export type VenueCreateInput = {
  /** GEO latitude coordinate */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** GEO longitude coordinate */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Name of the venue that will be displayed. */
  name: Scalars['String']['input'];
};

/** A viewer context representation. */
export type Viewer = {
  __typename?: 'Viewer';
  /** The used viewer authentication method if the request got authenticated via token. */
  authenticationMethod: AuthenticationMethod;
  /** Global available categories. */
  categories?: Maybe<Array<Category>>;
  /** Single event by identifier or key for simple access. */
  event?: Maybe<Event>;
  /**
   * Event teaser collection with search and filter options.
   *
   * In case a search string is passed, the sorting is done by relevance. Otherwise it is sorted ascending by date.
   */
  eventTeasers?: Maybe<EventTeaserCollection>;
  eventType?: Maybe<EventType>;
  /** Available event types. */
  eventTypes: Array<EventType>;
  /** A user profile */
  user?: Maybe<User>;
  /** Available venues. Global venues and those matching the given eventType Id. */
  venues?: Maybe<VenueCollection>;
  /** The authenticated user profile. A user profile is authenticated by SSO or username/password login. */
  viewerUser?: Maybe<ViewerUser>;
};


/** A viewer context representation. */
export type ViewerCategoriesArgs = {
  filter?: InputMaybe<ViewerCategoriesFilter>;
};


/** A viewer context representation. */
export type ViewerEventArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};


/** A viewer context representation. */
export type ViewerEventTeasersArgs = {
  filter?: InputMaybe<ViewerEventsFilter>;
  limit?: InputMaybe<CollectionLimt>;
};


/** A viewer context representation. */
export type ViewerEventTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};


/** A viewer context representation. */
export type ViewerEventTypesArgs = {
  filter?: InputMaybe<ViewerEventTypesFilter>;
};


/** A viewer context representation. */
export type ViewerUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** A viewer context representation. */
export type ViewerVenuesArgs = {
  filter?: InputMaybe<ViewerVenuesFilter>;
  limit?: InputMaybe<CollectionLimt>;
};

/** Filter for categories */
export type ViewerCategoriesFilter = {
  /** Flag to include only categories of events that are shown in the app library */
  filterAppLibraryOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filter for events types */
export type ViewerEventTypesFilter = {
  /** Flag to include only event types to be shown in the app library */
  filterAppLibraryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag to include only event types to be shown in the app library */
  filterEventCreationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag to include only event types to be shown in the public library on the login screen */
  filterPublicLibraryOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filter for events collection */
export type ViewerEventsFilter = {
  /**
   * Flag to include only events of event types to be shown in the app library
   *
   * Relevant to be set for the app library dependent on the user's permission.
   */
  filterAppLibraryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Category UUIDs filter */
  filterCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Event type UUIDs for filter */
  filterEventTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Event type keys for filter */
  filterEventTypeKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Earliest start date filter */
  filterFromDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Flag to include only promoted events */
  filterPromotedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Latest end date filter */
  filterToDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Full-text search parameter */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** A invitee object representation */
export type ViewerInvitee = Person & {
  __typename?: 'ViewerInvitee';
  /** All companions of the invitee */
  companions: Array<Companion>;
  company: Scalars['String']['output'];
  complianceFormDownloadUrl?: Maybe<Scalars['String']['output']>;
  complianceFormUploadUrl?: Maybe<Scalars['String']['output']>;
  complianceProcess: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** UUID of the invitee object */
  id: Scalars['ID']['output'];
  /** The invitee status */
  inviteeStatus: InviteeStatus;
  jobTitle: Scalars['String']['output'];
  /** The identifier of the invitee's language */
  language?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  /** The operation the invitee is invited to */
  operation: InviteeOperation;
  phone: Scalars['String']['output'];
  respondable: Scalars['Boolean']['output'];
  thumbnail?: Maybe<Image>;
};

/** A ViewerParticipant mutation response object */
export type ViewerInviteeMutationOutput = MutationOutput & {
  __typename?: 'ViewerInviteeMutationOutput';
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** The mutated ViewerInvitee */
  object?: Maybe<ViewerInvitee>;
};

/** A participant object representation */
export type ViewerParticipant = Participant & Person & {
  __typename?: 'ViewerParticipant';
  /** The identifier to authenticate the participant */
  accessIdentifier: Scalars['String']['output'];
  /** All bookings of the participant */
  bookings: Array<Booking>;
  /** Cancellation object if participant has cancelled its participation */
  cancellation?: Maybe<Cancellation>;
  /** All companions of the participant */
  companions: Array<Companion>;
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** UUID of the participant object */
  id: Scalars['ID']['output'];
  /** Participants input fields entered during the booking process */
  inputFieldValues: Array<InputFieldValue>;
  /** The identifier of the participant's language */
  language?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  /** The participant status */
  participantStatus: ParticipantStatus;
  phone: Scalars['String']['output'];
  /** Flag to indicate whether the participant is shown in the participant list or not */
  public: Scalars['Boolean']['output'];
  /** The representative of the companion */
  representative?: Maybe<Companion>;
  /** The participant thumbnail image (portrait). As fallback, the user thumbnail image is set. */
  thumbnail?: Maybe<Image>;
  /** The user profile of the participant if available */
  userId?: Maybe<Scalars['ID']['output']>;
};


/** A participant object representation */
export type ViewerParticipantBookingsArgs = {
  statuses?: InputMaybe<Array<BookingStatus>>;
};

/** A ViewerParticipant mutation response object */
export type ViewerParticipantMutationOutput = MutationOutput & {
  __typename?: 'ViewerParticipantMutationOutput';
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** The mutated ViewerParticipant */
  object?: Maybe<ViewerParticipant>;
};

/** A full user object representation for the authenticated user */
export type ViewerUser = Person & User & {
  __typename?: 'ViewerUser';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  /** UUID of the object */
  id: Scalars['ID']['output'];
  /** The user image (header) */
  image?: Maybe<Image>;
  /** The user's preferred language */
  language?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  /** Events the user is organizer of */
  organizerEvents?: Maybe<EventTeaserCollection>;
  /** Events the user participates in */
  participantEvents?: Maybe<EventTeaserCollection>;
  phone: Scalars['String']['output'];
  /** Events the user has pending reservations */
  reservationEvents?: Maybe<EventTeaserCollection>;
  /** The user thumbnail image (portrait) */
  thumbnail?: Maybe<Image>;
  /** Unique username can be e-mail or any other string */
  username: Scalars['String']['output'];
};


/** A full user object representation for the authenticated user */
export type ViewerUserOrganizerEventsArgs = {
  limit?: InputMaybe<CollectionLimt>;
};


/** A full user object representation for the authenticated user */
export type ViewerUserParticipantEventsArgs = {
  limit?: InputMaybe<CollectionLimt>;
};


/** A full user object representation for the authenticated user */
export type ViewerUserReservationEventsArgs = {
  limit?: InputMaybe<CollectionLimt>;
};

/** A ViewerUser mutation response object */
export type ViewerUserMutationOutput = MutationOutput & {
  __typename?: 'ViewerUserMutationOutput';
  /** Error if an error appeared due to the user input. */
  inputError?: Maybe<Error>;
  /** The mutated ViewerUser */
  object?: Maybe<ViewerUser>;
};

/** Filter for venues collection */
export type ViewerVenuesFilter = {
  /**
   * Event type UUID for filter. Always provide this if the venues are used within a specific event type. Global venues
   *
   * are still returned in any case.
   */
  filterEventTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** Full-text search parameter */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** A waitinglist configuration */
export type Waitinglist = {
  __typename?: 'Waitinglist';
  /** Capacity definition of the operation. This object is undefined in case the waitinglist size is not exposed. */
  capacity?: Maybe<Capacity>;
};

type AdditionalFieldsAdditionalEmailFieldFragment = { __typename?: 'AdditionalEmailField', email: string, label: string };

type AdditionalFieldsAdditionalFileListFieldFragment = { __typename?: 'AdditionalFileListField', label: string, files: Array<{ __typename?: 'File', title: string, caption: string, resource?: any | null }> };

type AdditionalFieldsAdditionalImageListFieldFragment = { __typename?: 'AdditionalImageListField', label: string, images: Array<{ __typename?: 'Image', title: string, caption: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null }> };

type AdditionalFieldsAdditionalLinkFieldFragment = { __typename?: 'AdditionalLinkField', text: string, url: string, target: string, label: string };

type AdditionalFieldsAdditionalMultilineFieldFragment = { __typename?: 'AdditionalMultilineField', text: string, label: string };

type AdditionalFieldsAdditionalSocialMediaFieldFragment = { __typename?: 'AdditionalSocialMediaField', label: string };

export type AdditionalFieldsFragment = AdditionalFieldsAdditionalEmailFieldFragment | AdditionalFieldsAdditionalFileListFieldFragment | AdditionalFieldsAdditionalImageListFieldFragment | AdditionalFieldsAdditionalLinkFieldFragment | AdditionalFieldsAdditionalMultilineFieldFragment | AdditionalFieldsAdditionalSocialMediaFieldFragment;

export type BookingFragment = { __typename?: 'Booking', id: string, bookingNr: string, bookingStatus: BookingStatus, creationDate?: any | null, includingVat: boolean, deletable: boolean, discount: number, discountVatPrice: number, registrationPrice: number, registrationVatPrice: number, eTicketUrl?: string | null, participant: { __typename?: 'ViewerParticipant', id: string, displayName: string, email: string, public: boolean, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }>, representative?: { __typename?: 'Companion', id: string, displayName: string, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }> } | null }, payment?: { __typename?: 'Payment', onlinePaymentRequired: boolean, commissionRate: number, commissionPrice: number, commissionVatPrice: number, totalPrice: number, totalVatPrice: number, vatRate: number, paymentStatus: PaymentStatus, totalPriceInclVatRounded: number, paymentType: { __typename?: 'PaymentType', name: string, gateway: boolean }, currency: { __typename?: 'Currency', name: string } } | null, bookingOperations: Array<{ __typename?: 'BookingOperation', id: string, bookingOperationStatus: BookingOperationStatus, groupBooking?: { __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null } | null, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }>, operation: { __typename?: 'Operation', id: string, title: string, description: string, online: boolean, price?: number | null, marketPrice?: number | null, priceBreakdown: string, parentId: string, operationDates: Array<{ __typename?: 'OperationDate', startDate: any, endDate: any }>, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, venue?: { __typename?: 'Venue', name: string } | null, capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, waitinglist?: { __typename?: 'Waitinglist', capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null } | null, viewerBookable?: { __typename?: 'Bookable', waitinglist: boolean, minimum: number, maximum: number, maximumCompanions?: number | null } | null, inputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }>, groupBookingDefinition?: { __typename?: 'GroupBookingDefinition', minimumGroupParticipants: number, maximumGroupParticipants?: number | null, groupCapacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, viewerGroupBookable?: { __typename?: 'Bookable', maximum: number } | null } | null, groupBookings?: { __typename?: 'GroupBookingCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null }> } | null }, companion?: { __typename?: 'Companion', id: string, displayName: string, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }> } | null }>, groupedBookingOperations: Array<{ __typename?: 'BookingOperationAggregation', count: number, bookingOperationStatus: BookingOperationStatus, vatRate: number, discount: number, discountVatPrice: number, discountPercentage: number, totalPrice: number, totalVatPrice: number, operationPrice: number, operation: { __typename?: 'Operation', id: string, title: string, description: string, online: boolean, price?: number | null, marketPrice?: number | null, priceBreakdown: string, parentId: string, operationDates: Array<{ __typename?: 'OperationDate', startDate: any, endDate: any }>, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, venue?: { __typename?: 'Venue', name: string } | null, capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, waitinglist?: { __typename?: 'Waitinglist', capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null } | null, viewerBookable?: { __typename?: 'Bookable', waitinglist: boolean, minimum: number, maximum: number, maximumCompanions?: number | null } | null, inputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }>, groupBookingDefinition?: { __typename?: 'GroupBookingDefinition', minimumGroupParticipants: number, maximumGroupParticipants?: number | null, groupCapacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, viewerGroupBookable?: { __typename?: 'Bookable', maximum: number } | null } | null, groupBookings?: { __typename?: 'GroupBookingCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null }> } | null }, bookingOperations: Array<{ __typename?: 'BookingOperation', id: string, bookingOperationStatus: BookingOperationStatus, groupBooking?: { __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null } | null, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }>, companion?: { __typename?: 'Companion', id: string, displayName: string, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }> } | null }> }>, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }> };

export type BrandingFragment = { __typename?: 'BrandingSetting', primaryColor: string, secondaryColor: string, backgroundColor: string, fontFile?: any | null, fontFamily?: string | null, logo?: { __typename?: 'Image', originalWidth: number, originalHeight: number, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null };

export type CompanionFragment = { __typename?: 'Companion', id: string, displayName: string, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }> };

export type DateTimeZoneFragment = { __typename?: 'DateTimeZone', name: string, default: boolean };

export type EventTeaserFragment = { __typename?: 'EventTeaser', id: string, key: string, title: string, startDate?: any | null, endDate?: any | null, lowestPrice?: number | null, currencyName?: string | null, online: boolean, promoted: boolean, venueName?: string | null, eventTypeKey: string, eventTypeName: string, timezone: { __typename?: 'DateTimeZone', name: string, default: boolean }, image?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, capacity: { __typename?: 'EventCapacity', count: number, maximum?: number | null, available?: number | null, waitinglist: boolean }, operations: Array<{ __typename?: 'OperationTeaser', id: string, title: string, online: boolean, operationDates: Array<{ __typename?: 'OperationDateTeaser', startDate: any, endDate: any }> }> };

export type GroupBookingFragment = { __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null };

export type ImageFragment = { __typename?: 'Image', title: string, caption: string, thumbnail?: { __typename?: 'Thumbnail', width?: number | null, height?: number | null, resource?: any | null } | null };

type InputCheckboxFieldFragment = { __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean };

type InputDatePickerFieldFragment = { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null };

type InputFileUploadFieldFragment = { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean };

type InputImageUploadFieldFragment = { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean };

type InputMultiLineTextFieldFragment = { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null };

type InputMultiSelectCheckboxesFieldFragment = { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> };

type InputSingleLineTextFieldFragment = { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null };

type InputSingleSelectDropdownFieldFragment = { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> };

type InputSingleSelectRadiobuttonsFieldFragment = { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> };

type InputStaticTextFieldFragment = { __typename?: 'StaticTextField', identifier: string, label: string, text: string };

export type InputFragment = InputCheckboxFieldFragment | InputDatePickerFieldFragment | InputFileUploadFieldFragment | InputImageUploadFieldFragment | InputMultiLineTextFieldFragment | InputMultiSelectCheckboxesFieldFragment | InputSingleLineTextFieldFragment | InputSingleSelectDropdownFieldFragment | InputSingleSelectRadiobuttonsFieldFragment | InputStaticTextFieldFragment;

type InputValueBooleanInputFieldValueFragment = { __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } };

type InputValueDateInputFieldValueFragment = { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } };

type InputValueFileInputFieldValueFragment = { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } };

type InputValueImageInputFieldValueFragment = { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } };

type InputValueListStringInputFieldValueFragment = { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } };

type InputValueStringInputFieldValueFragment = { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } };

export type InputValueFragment = InputValueBooleanInputFieldValueFragment | InputValueDateInputFieldValueFragment | InputValueFileInputFieldValueFragment | InputValueImageInputFieldValueFragment | InputValueListStringInputFieldValueFragment | InputValueStringInputFieldValueFragment;

type OnlineEventSettingsExternalOnlineEventSettingFragment = { __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string };

type OnlineEventSettingsInternalOnlineEventSettingFragment = { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string };

export type OnlineEventSettingsFragment = OnlineEventSettingsExternalOnlineEventSettingFragment | OnlineEventSettingsInternalOnlineEventSettingFragment;

export type OperationFragment = { __typename?: 'Operation', id: string, title: string, description: string, online: boolean, price?: number | null, marketPrice?: number | null, priceBreakdown: string, parentId: string, operationDates: Array<{ __typename?: 'OperationDate', startDate: any, endDate: any }>, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, venue?: { __typename?: 'Venue', name: string } | null, capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, waitinglist?: { __typename?: 'Waitinglist', capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null } | null, viewerBookable?: { __typename?: 'Bookable', waitinglist: boolean, minimum: number, maximum: number, maximumCompanions?: number | null } | null, inputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }>, groupBookingDefinition?: { __typename?: 'GroupBookingDefinition', minimumGroupParticipants: number, maximumGroupParticipants?: number | null, groupCapacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, viewerGroupBookable?: { __typename?: 'Bookable', maximum: number } | null } | null, groupBookings?: { __typename?: 'GroupBookingCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null }> } | null };

export type RegisterOperationFragment = { __typename?: 'Operation', id: string, title: string, description: string, online: boolean, price?: number | null, marketPrice?: number | null, priceBreakdown: string, parentId: string, operationDates: Array<{ __typename?: 'OperationDate', startDate: any, endDate: any }>, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, venue?: { __typename?: 'Venue', name: string } | null, capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, waitinglist?: { __typename?: 'Waitinglist', capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null } | null, viewerBookable?: { __typename?: 'Bookable', waitinglist: boolean, minimum: number, maximum: number, maximumCompanions?: number | null } | null, inputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }>, groupBookingDefinition?: { __typename?: 'GroupBookingDefinition', minimumGroupParticipants: number, maximumGroupParticipants?: number | null, groupCapacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, viewerGroupBookable?: { __typename?: 'Bookable', maximum: number } | null } | null, groupBookings?: { __typename?: 'GroupBookingCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null }> } | null };

export type AcceptInviteeMutationVariables = Exact<{
  token: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
}>;


export type AcceptInviteeMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', viewerInvitee?: { __typename?: 'MutationViewerInvitee', accept: { __typename?: 'ViewerInviteeMutationOutput', inputError?: { __typename?: 'Error', message: string } | null, object?: { __typename?: 'ViewerInvitee', inviteeStatus: InviteeStatus } | null } } | null } | null } | null };

export type AccessCodeLoginMutationVariables = Exact<{
  accessCode: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
}>;


export type AccessCodeLoginMutation = { __typename?: 'Mutation', authentication: { __typename?: 'Authentication', createTokenByAccessCode?: { __typename?: 'TokenMutationOutput', token: string } | null } };

export type AddGroupBookingParticipantMutationVariables = Exact<{
  token: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  groupBookingId: Scalars['ID']['input'];
  participantUsernameOrEmail: Scalars['String']['input'];
}>;


export type AddGroupBookingParticipantMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', viewerParticipant?: { __typename?: 'MutationViewerParticipant', addGroupBookingParticipant: { __typename?: 'GroupBookingMutationOutput', inputError?: { __typename?: 'Error', message: string } | null } } | null } | null } | null };

export type CancelBookingMutationVariables = Exact<{
  token: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  bookingId: Scalars['ID']['input'];
}>;


export type CancelBookingMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', viewerParticipant?: { __typename?: 'MutationViewerParticipant', cancelBooking: { __typename?: 'BookingMutationOutput', inputError?: { __typename?: 'Error', message: string } | null } } | null } | null } | null };

export type CheckInParticipantMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  onlineEventSettingId: Scalars['ID']['input'];
}>;


export type CheckInParticipantMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', viewerParticipant?: { __typename?: 'MutationViewerParticipant', checkInByOnlineEventSetting: { __typename?: 'ViewerParticipantMutationOutput', inputError?: { __typename?: 'Error', message: string } | null } } | null } | null } | null };

export type ConfirmBookingMutationVariables = Exact<{
  token: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  bookingId: Scalars['ID']['input'];
}>;


export type ConfirmBookingMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', viewerParticipant?: { __typename?: 'MutationViewerParticipant', confirmBooking: { __typename?: 'BookingMutationOutput', inputError?: { __typename?: 'Error', message: string } | null, object?: { __typename?: 'Booking', bookingStatus: BookingStatus } | null } } | null } | null } | null };

export type ConfirmBookingOperationsMutationVariables = Exact<{
  token: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  bookingOperationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ConfirmBookingOperationsMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', viewerParticipant?: { __typename?: 'MutationViewerParticipant', confirmBookingOperations: { __typename?: 'BookingOperationsMutationOutput', inputError?: { __typename?: 'Error', message: string } | null } } | null } | null } | null };

export type CreateBookingMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  operations: Array<BookingOperationCreateInput> | BookingOperationCreateInput;
  companions?: InputMaybe<Array<CompanionBookingOperationCreateInput> | CompanionBookingOperationCreateInput>;
}>;


export type CreateBookingMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', createBooking?: { __typename?: 'BookingMutationOutput', inputError?: { __typename?: 'Error', message: string } | null, object?: { __typename?: 'Booking', bookingNr: string, participant: { __typename?: 'ViewerParticipant', accessIdentifier: string } } | null } | null } | null } | null };

export type CreateCancellationMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  inputFieldValues: Array<InputFieldValueInput> | InputFieldValueInput;
}>;


export type CreateCancellationMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', createCancellation?: { __typename?: 'CancellationMutationOutput', object?: { __typename?: 'Cancellation', participant: { __typename?: 'ViewerParticipant', accessIdentifier: string } } | null, inputError?: { __typename?: 'Error', message: string } | null } | null } | null } | null };

export type CreateCommentMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  captcha?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', createComment?: { __typename?: 'CommentMutationOutput', inputError?: { __typename?: 'Error', message: string } | null } | null } | null } | null };

export type CreateEventMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  image?: InputMaybe<Scalars['Resource']['input']>;
  eventTypeId: Scalars['ID']['input'];
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
  newVenue?: InputMaybe<VenueCreateInput>;
  onlineEventSetting?: InputMaybe<ExternalOnlineEventSettingInput>;
  operationDates: Array<OperationDateCreateInput> | OperationDateCreateInput;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  minParticipant?: InputMaybe<Scalars['Int']['input']>;
  maxParticipant?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', createEvent?: { __typename?: 'EventMutationOutput', inputError?: { __typename?: 'Error', message: string } | null } | null } | null };

export type CreateUserMutationVariables = Exact<{
  user: UserCreateInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', user?: { __typename?: 'MutationUser', createUser?: { __typename?: 'GenericMutationOutput', success: boolean, inputError?: { __typename?: 'Error', message: string } | null } | null } | null } | null };

export type DeleteBookingMutationVariables = Exact<{
  token: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  bookingId: Scalars['ID']['input'];
}>;


export type DeleteBookingMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', viewerParticipant?: { __typename?: 'MutationViewerParticipant', deleteBooking: { __typename?: 'BookingMutationOutput', inputError?: { __typename?: 'Error', message: string } | null } } | null } | null } | null };

export type DeleteBookingOperationsMutationVariables = Exact<{
  token: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  bookingOperationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteBookingOperationsMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', viewerParticipant?: { __typename?: 'MutationViewerParticipant', deleteBookingOperations: { __typename?: 'BookingOperationsMutationOutput', inputError?: { __typename?: 'Error', message: string } | null } } | null } | null } | null };

export type DeleteCommentMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  commentId: Scalars['ID']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', deleteComment?: { __typename?: 'CommentMutationOutput', inputError?: { __typename?: 'Error', message: string } | null } | null } | null } | null };

export type ParticipantLoginMutationVariables = Exact<{
  accessIdentifier: Scalars['String']['input'];
}>;


export type ParticipantLoginMutation = { __typename?: 'Mutation', authentication: { __typename?: 'Authentication', createTokenByParticipant?: { __typename?: 'TokenMutationOutput', token: string } | null } };

export type RejectInviteeMutationVariables = Exact<{
  token: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
}>;


export type RejectInviteeMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', viewerInvitee?: { __typename?: 'MutationViewerInvitee', reject: { __typename?: 'ViewerInviteeMutationOutput', inputError?: { __typename?: 'Error', message: string } | null, object?: { __typename?: 'ViewerInvitee', inviteeStatus: InviteeStatus } | null } } | null } | null } | null };

export type RemoveGroupBookingParticipantMutationVariables = Exact<{
  token: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  groupBookingId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
}>;


export type RemoveGroupBookingParticipantMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', viewerParticipant?: { __typename?: 'MutationViewerParticipant', removeGroupBookingParticipant: { __typename?: 'GroupBookingMutationOutput', inputError?: { __typename?: 'Error', message: string } | null } } | null } | null } | null };

export type RequestPasswordResetMutationVariables = Exact<{
  user: UserInput;
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', user?: { __typename?: 'MutationUser', requestPasswordReset: { __typename?: 'GenericMutationOutput', success: boolean, inputError?: { __typename?: 'Error', message: string } | null } } | null } | null };

export type ResendBookingConfirmationByParticipantEmailMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type ResendBookingConfirmationByParticipantEmailMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', resendBookingConfirmationByParticipantEmail: { __typename?: 'GenericMutationOutput', success: boolean, inputError?: { __typename?: 'Error', message: string } | null } } | null } | null };

export type ResendBookingConfirmationMutationVariables = Exact<{
  token: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  bookingId: Scalars['ID']['input'];
}>;


export type ResendBookingConfirmationMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', viewerParticipant?: { __typename?: 'MutationViewerParticipant', resendBookingConfirmation: { __typename?: 'BookingMutationOutput', inputError?: { __typename?: 'Error', message: string } | null } } | null } | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', user?: { __typename?: 'MutationUser', resetPassword: { __typename?: 'ViewerUserMutationOutput', inputError?: { __typename?: 'Error', message: string } | null } } | null } | null };

export type SendEmailMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  message: MessageInput;
  sender?: InputMaybe<MessageSenderInput>;
}>;


export type SendEmailMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', sendEmailMessage?: { __typename?: 'GenericMutationOutput', success: boolean, inputError?: { __typename?: 'Error', message: string } | null } | null } | null } | null };

export type SendGlobalEmailMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  message: MessageInput;
  sender?: InputMaybe<MessageSenderInput>;
}>;


export type SendGlobalEmailMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', sendEmailMessage?: { __typename?: 'GenericMutationOutput', success: boolean, inputError?: { __typename?: 'Error', message: string } | null } | null } | null };

export type SsoLoginMutationVariables = Exact<{
  callbackUri: Scalars['String']['input'];
}>;


export type SsoLoginMutation = { __typename?: 'Mutation', authentication: { __typename?: 'Authentication', ssoUri?: string | null } };

export type UpdateBookingMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  bookingId: Scalars['ID']['input'];
  operations?: InputMaybe<Array<BookingOperationCreateInput> | BookingOperationCreateInput>;
  companions?: InputMaybe<Array<CompanionBookingOperationCreateInput> | CompanionBookingOperationCreateInput>;
}>;


export type UpdateBookingMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', viewerParticipant?: { __typename?: 'MutationViewerParticipant', updateBooking: { __typename?: 'BookingMutationOutput', inputError?: { __typename?: 'Error', message: string } | null, object?: { __typename?: 'Booking', bookingNr: string, participant: { __typename?: 'ViewerParticipant', accessIdentifier: string } } | null } } | null } | null } | null };

export type UpdateGroupBookingMutationVariables = Exact<{
  token: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  groupBookingId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  public: Scalars['Boolean']['input'];
}>;


export type UpdateGroupBookingMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', viewerParticipant?: { __typename?: 'MutationViewerParticipant', updateGroupBooking?: { __typename?: 'GroupBookingMutationOutput', inputError?: { __typename?: 'Error', message: string } | null } | null } | null } | null } | null };

export type UpdateParticipantMutationVariables = Exact<{
  token: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  inputFieldValues: Array<InputFieldValueInput> | InputFieldValueInput;
  representative?: InputMaybe<CompanionCreateInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  bookingId: Scalars['ID']['input'];
  bookingInputFieldValues: Array<InputFieldValueInput> | InputFieldValueInput;
}>;


export type UpdateParticipantMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', event?: { __typename?: 'MutationEvent', viewerParticipant?: { __typename?: 'MutationViewerParticipant', updateParticipant: { __typename?: 'ViewerParticipantMutationOutput', inputError?: { __typename?: 'Error', message: string } | null }, updateBooking: { __typename?: 'BookingMutationOutput', inputError?: { __typename?: 'Error', message: string } | null } } | null } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  token: Scalars['String']['input'];
  user: UserUpdateInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'MutationViewer', updateUser?: { __typename?: 'ViewerUserMutationOutput', inputError?: { __typename?: 'Error', message: string } | null } | null } | null };

export type UsernamePasswordLoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type UsernamePasswordLoginMutation = { __typename?: 'Mutation', authentication: { __typename?: 'Authentication', createTokenByUsernamePassword?: { __typename?: 'TokenMutationOutput', token: string } | null } };

export type AppQueryVariables = Exact<{ [key: string]: never; }>;


export type AppQuery = { __typename?: 'Query', app: { __typename?: 'App', authenticationMethods: Array<AuthenticationMethod>, eventCreation: boolean, userRegistration: boolean, branding: { __typename?: 'BrandingSetting', primaryColor: string, secondaryColor: string, backgroundColor: string, fontFile?: any | null, fontFamily?: string | null, logo?: { __typename?: 'Image', originalWidth: number, originalHeight: number, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null } } };

export type BookingsQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  eventKeyOrId: Scalars['String']['input'];
}>;


export type BookingsQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', authenticationMethod: AuthenticationMethod, event?: { __typename?: 'Event', id: string, key: string, title: string, authenticationMethods: Array<AuthenticationMethod>, startDate?: any | null, endDate?: any | null, deadline?: any | null, timezone: { __typename?: 'DateTimeZone', name: string, default: boolean }, capacity?: { __typename?: 'EventCapacity', available?: number | null, waitinglist: boolean, bookable: boolean } | null, onlineEventSettings?: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }> | null, viewerRegistration?: { __typename?: 'Registration', running: boolean, participantDefinition: { __typename?: 'ParticipantDefinition', cancellation: boolean, cancellationInputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }> } } | null, viewerParticipant?: { __typename?: 'ViewerParticipant', id: string, bookings: Array<{ __typename?: 'Booking', id: string, bookingNr: string, bookingStatus: BookingStatus, creationDate?: any | null, includingVat: boolean, deletable: boolean, discount: number, discountVatPrice: number, registrationPrice: number, registrationVatPrice: number, eTicketUrl?: string | null, participant: { __typename?: 'ViewerParticipant', id: string, displayName: string, email: string, public: boolean, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }>, representative?: { __typename?: 'Companion', id: string, displayName: string, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }> } | null }, payment?: { __typename?: 'Payment', onlinePaymentRequired: boolean, commissionRate: number, commissionPrice: number, commissionVatPrice: number, totalPrice: number, totalVatPrice: number, vatRate: number, paymentStatus: PaymentStatus, totalPriceInclVatRounded: number, paymentType: { __typename?: 'PaymentType', name: string, gateway: boolean }, currency: { __typename?: 'Currency', name: string } } | null, bookingOperations: Array<{ __typename?: 'BookingOperation', id: string, bookingOperationStatus: BookingOperationStatus, groupBooking?: { __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null } | null, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }>, operation: { __typename?: 'Operation', id: string, title: string, description: string, online: boolean, price?: number | null, marketPrice?: number | null, priceBreakdown: string, parentId: string, operationDates: Array<{ __typename?: 'OperationDate', startDate: any, endDate: any }>, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, venue?: { __typename?: 'Venue', name: string } | null, capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, waitinglist?: { __typename?: 'Waitinglist', capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null } | null, viewerBookable?: { __typename?: 'Bookable', waitinglist: boolean, minimum: number, maximum: number, maximumCompanions?: number | null } | null, inputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }>, groupBookingDefinition?: { __typename?: 'GroupBookingDefinition', minimumGroupParticipants: number, maximumGroupParticipants?: number | null, groupCapacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, viewerGroupBookable?: { __typename?: 'Bookable', maximum: number } | null } | null, groupBookings?: { __typename?: 'GroupBookingCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null }> } | null }, companion?: { __typename?: 'Companion', id: string, displayName: string, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }> } | null }>, groupedBookingOperations: Array<{ __typename?: 'BookingOperationAggregation', count: number, bookingOperationStatus: BookingOperationStatus, vatRate: number, discount: number, discountVatPrice: number, discountPercentage: number, totalPrice: number, totalVatPrice: number, operationPrice: number, operation: { __typename?: 'Operation', id: string, title: string, description: string, online: boolean, price?: number | null, marketPrice?: number | null, priceBreakdown: string, parentId: string, operationDates: Array<{ __typename?: 'OperationDate', startDate: any, endDate: any }>, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, venue?: { __typename?: 'Venue', name: string } | null, capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, waitinglist?: { __typename?: 'Waitinglist', capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null } | null, viewerBookable?: { __typename?: 'Bookable', waitinglist: boolean, minimum: number, maximum: number, maximumCompanions?: number | null } | null, inputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }>, groupBookingDefinition?: { __typename?: 'GroupBookingDefinition', minimumGroupParticipants: number, maximumGroupParticipants?: number | null, groupCapacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, viewerGroupBookable?: { __typename?: 'Bookable', maximum: number } | null } | null, groupBookings?: { __typename?: 'GroupBookingCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null }> } | null }, bookingOperations: Array<{ __typename?: 'BookingOperation', id: string, bookingOperationStatus: BookingOperationStatus, groupBooking?: { __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null } | null, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }>, companion?: { __typename?: 'Companion', id: string, displayName: string, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }> } | null }> }>, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }> }>, cancellation?: { __typename?: 'Cancellation', id: string } | null, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }> } | null, operations?: Array<{ __typename?: 'Operation', id: string, title: string, description: string, online: boolean, price?: number | null, marketPrice?: number | null, priceBreakdown: string, parentId: string, viewerBookable?: { __typename?: 'Bookable', maximum: number, waitinglist: boolean, minimum: number, maximumCompanions?: number | null } | null, operationDates: Array<{ __typename?: 'OperationDate', startDate: any, endDate: any }>, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, venue?: { __typename?: 'Venue', name: string } | null, capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, waitinglist?: { __typename?: 'Waitinglist', capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null } | null, inputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }>, groupBookingDefinition?: { __typename?: 'GroupBookingDefinition', minimumGroupParticipants: number, maximumGroupParticipants?: number | null, groupCapacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, viewerGroupBookable?: { __typename?: 'Bookable', maximum: number } | null } | null, groupBookings?: { __typename?: 'GroupBookingCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null }> } | null }> | null, subEvents?: Array<{ __typename?: 'SubEvent', id: string, title: string, startDate: any, endDate: any, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, operations: Array<{ __typename?: 'Operation', id: string, title: string, description: string, online: boolean, price?: number | null, marketPrice?: number | null, priceBreakdown: string, parentId: string, viewerBookable?: { __typename?: 'Bookable', maximum: number, waitinglist: boolean, minimum: number, maximumCompanions?: number | null } | null, operationDates: Array<{ __typename?: 'OperationDate', startDate: any, endDate: any }>, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, venue?: { __typename?: 'Venue', name: string } | null, capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, waitinglist?: { __typename?: 'Waitinglist', capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null } | null, inputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }>, groupBookingDefinition?: { __typename?: 'GroupBookingDefinition', minimumGroupParticipants: number, maximumGroupParticipants?: number | null, groupCapacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, viewerGroupBookable?: { __typename?: 'Bookable', maximum: number } | null } | null, groupBookings?: { __typename?: 'GroupBookingCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null }> } | null }> }> | null } | null } | null };

export type CategoriesAndEventTypesQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  filterActiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
  filterAppLibraryOnly: Scalars['Boolean']['input'];
  filterEventCreationOnly: Scalars['Boolean']['input'];
}>;


export type CategoriesAndEventTypesQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', categories?: Array<{ __typename?: 'Category', id: string, name: string, image?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null }> | null, eventTypes: Array<{ __typename?: 'EventType', id: string, key: string, name: string, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null }> } | null };

export type CommentsQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  eventKeyOrId: Scalars['String']['input'];
  length?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CommentsQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', event?: { __typename?: 'Event', id: string, comments?: { __typename?: 'CommentCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'Comment', id: string, firstName: string, lastName: string, userId?: string | null, creationDate: any, text: string, deletable: boolean, thumbnail?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null }> } | null } | null } | null };

export type EventDatesQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  length: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  filterFromDate: Scalars['DateTime']['input'];
  filterToDate: Scalars['DateTime']['input'];
  filterCategoryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filterEventTypeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type EventDatesQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', dates?: { __typename?: 'EventTeaserCollection', items: Array<{ __typename?: 'EventTeaser', timezone: { __typename?: 'DateTimeZone', name: string, default: boolean }, operations: Array<{ __typename?: 'OperationTeaser', operationDates: Array<{ __typename?: 'OperationDateTeaser', startDate: any, endDate: any }> }> }> } | null } | null };

export type EventQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  eventKeyOrId: Scalars['String']['input'];
}>;


export type EventQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', event?: { __typename?: 'Event', id: string, key: string, title: string, authenticationMethods: Array<AuthenticationMethod>, startDate?: any | null, endDate?: any | null, deadline?: any | null, description?: string | null, layout: Layout, online: boolean, lowestPrice?: number | null, agendaFeature?: boolean | null, speakerFeature?: boolean | null, participantFeature?: boolean | null, viewerParticipantFeature?: boolean | null, commentFeature?: boolean | null, viewerCommentFeature?: boolean | null, language: { __typename?: 'Language', default: string, available: Array<string> }, timezone: { __typename?: 'DateTimeZone', name: string, default: boolean }, capacity?: { __typename?: 'EventCapacity', available?: number | null, waitinglist: boolean, bookable: boolean } | null, image?: { __typename?: 'Image', small?: { __typename?: 'Thumbnail', resource?: any | null } | null, medium?: { __typename?: 'Thumbnail', resource?: any | null } | null, large?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, wideImage?: { __typename?: 'Image', small?: { __typename?: 'Thumbnail', resource?: any | null } | null, medium?: { __typename?: 'Thumbnail', resource?: any | null } | null, large?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, branding?: { __typename?: 'BrandingSetting', primaryColor: string, secondaryColor: string, backgroundColor: string, fontFile?: any | null, fontFamily?: string | null, logo?: { __typename?: 'Image', originalWidth: number, originalHeight: number, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null } | null, payment?: { __typename?: 'PaymentSetting', currency: { __typename?: 'Currency', name: string } } | null, eventType: { __typename?: 'EventType', key: string, name: string, domain: string, standaloneLibrary: boolean, appLibrary: boolean }, onlineEventSettings?: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }> | null, venue?: { __typename?: 'Venue', name: string, latitude?: number | null, longitude?: number | null } | null, viewerRegistration?: { __typename?: 'Registration', running: boolean, cancellation: boolean, participantDefinition: { __typename?: 'ParticipantDefinition', publicParticipantOptIn: ParticipantFeatureSetting } } | null, viewerParticipant?: { __typename?: 'ViewerParticipant', id: string, accessIdentifier: string, firstName: string, lastName: string, displayName: string, email: string, cancellation?: { __typename?: 'Cancellation', id: string } | null } | null, viewerInvitee?: { __typename?: 'ViewerInvitee', id: string, firstName: string, lastName: string, displayName: string, inviteeStatus: InviteeStatus, email: string, phone: string, language?: string | null, company: string, jobTitle: string, complianceProcess: boolean, complianceFormDownloadUrl?: string | null, complianceFormUploadUrl?: string | null, respondable: boolean, operation: { __typename?: 'InviteeOperation', id: string, title: string, marketPrice?: number | null, priceBreakdown: string, venue?: { __typename?: 'Venue', name: string } | null, operationDates: Array<{ __typename?: 'OperationDate', startDate: any, endDate: any }> }, companions: Array<{ __typename?: 'Companion', id: string, displayName: string }> } | null, organizerUsers?: Array<{ __typename?: 'GenericPerson', id: string, firstName: string, lastName: string, displayName: string, thumbnail?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', width?: number | null, height?: number | null, resource?: any | null } | null } | null }> | null, organizerOrganizations?: Array<{ __typename?: 'Organization', id: string, name: string, image?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', width?: number | null, height?: number | null, resource?: any | null } | null } | null }> | null, additionalFields?: Array<{ __typename?: 'AdditionalEmailField', email: string, label: string } | { __typename?: 'AdditionalFileListField', label: string, files: Array<{ __typename?: 'File', title: string, caption: string, resource?: any | null }> } | { __typename?: 'AdditionalImageListField', label: string, images: Array<{ __typename?: 'Image', title: string, caption: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null }> } | { __typename?: 'AdditionalLinkField', text: string, url: string, target: string, label: string } | { __typename?: 'AdditionalMultilineField', text: string, label: string } | { __typename?: 'AdditionalSocialMediaField', label: string }> | null, agenda?: Array<{ __typename?: 'AgendaItem', id: string, title: string, startDate: any, endDate: any, lead: string, description: string, tags: Array<string>, image?: { __typename?: 'Image', title: string, caption: string, thumbnail?: { __typename?: 'Thumbnail', width?: number | null, height?: number | null, resource?: any | null } | null } | null, additionalFields: Array<{ __typename?: 'AdditionalEmailField', email: string, label: string } | { __typename?: 'AdditionalFileListField', label: string, files: Array<{ __typename?: 'File', title: string, caption: string, resource?: any | null }> } | { __typename?: 'AdditionalImageListField', label: string, images: Array<{ __typename?: 'Image', title: string, caption: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null }> } | { __typename?: 'AdditionalLinkField', text: string, url: string, target: string, label: string } | { __typename?: 'AdditionalMultilineField', text: string, label: string } | { __typename?: 'AdditionalSocialMediaField', label: string }>, speakers: Array<{ __typename?: 'Speaker', id: string, firstName: string, lastName: string, displayName: string, thumbnail?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null }>, venue?: { __typename?: 'Venue', name: string } | null }> | null, operations?: Array<{ __typename?: 'Operation', id: string, title: string, description: string, online: boolean, operationDates: Array<{ __typename?: 'OperationDate', startDate: any, endDate: any }>, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }> }> | null, subEvents?: Array<{ __typename?: 'SubEvent', id: string, title: string, startDate: any, endDate: any, description: string, online: boolean, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, operations: Array<{ __typename?: 'Operation', id: string, title: string, description: string, online: boolean, operationDates: Array<{ __typename?: 'OperationDate', startDate: any, endDate: any }>, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, capacity?: { __typename?: 'Capacity', maximum?: number | null, available?: number | null } | null, totalBookingCounts: { __typename?: 'BookingAggregation', total: number } }> }> | null } | null } | null };

export type EventTeasersQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  length?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  filterFromDate?: InputMaybe<Scalars['DateTime']['input']>;
  filterToDate?: InputMaybe<Scalars['DateTime']['input']>;
  filterCategoryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filterEventTypeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filterAppLibraryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  filterPromotedOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EventTeasersQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', eventTeasers?: { __typename?: 'EventTeaserCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'EventTeaser', id: string, key: string, title: string, startDate?: any | null, endDate?: any | null, lowestPrice?: number | null, currencyName?: string | null, online: boolean, promoted: boolean, venueName?: string | null, eventTypeKey: string, eventTypeName: string, timezone: { __typename?: 'DateTimeZone', name: string, default: boolean }, image?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, capacity: { __typename?: 'EventCapacity', count: number, maximum?: number | null, available?: number | null, waitinglist: boolean }, operations: Array<{ __typename?: 'OperationTeaser', id: string, title: string, online: boolean, operationDates: Array<{ __typename?: 'OperationDateTeaser', startDate: any, endDate: any }> }> }> } | null } | null };

export type EventTypeQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  eventTypeKeyOrId: Scalars['String']['input'];
  contentSectionKey?: InputMaybe<Scalars['String']['input']>;
  categoriesFilterActiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
  eventTeasersLength?: InputMaybe<Scalars['Int']['input']>;
  eventTeasersOffset?: InputMaybe<Scalars['Int']['input']>;
  eventTeasersSearch?: InputMaybe<Scalars['String']['input']>;
  eventTeasersFilterFromDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventTeasersFilterToDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventTeasersFilterCategoryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  eventTeasersFilterPromotedOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EventTypeQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', eventType?: { __typename?: 'EventType', id: string, key: string, name: string, domain: string, authenticationMethods: Array<AuthenticationMethod>, standaloneLibrary: boolean, eventCreation: boolean, image?: { __typename?: 'Image', small?: { __typename?: 'Thumbnail', resource?: any | null } | null, medium?: { __typename?: 'Thumbnail', resource?: any | null } | null, large?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, contentSection?: { __typename?: 'ContentSection', id: string, key: string, title: string, text: string, additionalFields: Array<{ __typename?: 'AdditionalEmailField', email: string, label: string } | { __typename?: 'AdditionalFileListField', label: string, files: Array<{ __typename?: 'File', title: string, caption: string, resource?: any | null }> } | { __typename?: 'AdditionalImageListField', label: string, images: Array<{ __typename?: 'Image', title: string, caption: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null }> } | { __typename?: 'AdditionalLinkField', text: string, url: string, target: string, label: string } | { __typename?: 'AdditionalMultilineField', text: string, label: string } | { __typename?: 'AdditionalSocialMediaField', label: string }> } | null, contentSections?: Array<{ __typename?: 'ContentSection', id: string, key: string, title: string }> | null, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, eventTeasers?: { __typename?: 'EventTeaserCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'EventTeaser', id: string, key: string, title: string, startDate?: any | null, endDate?: any | null, lowestPrice?: number | null, currencyName?: string | null, online: boolean, promoted: boolean, venueName?: string | null, eventTypeKey: string, eventTypeName: string, timezone: { __typename?: 'DateTimeZone', name: string, default: boolean }, image?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, capacity: { __typename?: 'EventCapacity', count: number, maximum?: number | null, available?: number | null, waitinglist: boolean }, operations: Array<{ __typename?: 'OperationTeaser', id: string, title: string, online: boolean, operationDates: Array<{ __typename?: 'OperationDateTeaser', startDate: any, endDate: any }> }> }> } | null, branding?: { __typename?: 'BrandingSetting', primaryColor: string, secondaryColor: string, backgroundColor: string, fontFile?: any | null, fontFamily?: string | null, logo?: { __typename?: 'Image', originalWidth: number, originalHeight: number, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null } | null } | null } | null };

export type LoginEventTypesQueryVariables = Exact<{
  locale: Scalars['String']['input'];
}>;


export type LoginEventTypesQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', eventTypes: Array<{ __typename?: 'EventType', id: string, key: string, url?: string | null, name: string, image?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null }> } | null };

export type ParticipantsQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  eventKeyOrId: Scalars['String']['input'];
  length: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type ParticipantsQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', event?: { __typename?: 'Event', participants?: { __typename?: 'ParticipantCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'GenericParticipant', id: string, firstName: string, lastName: string, displayName: string, userId?: string | null, thumbnail?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null }> } | null } | null } | null };

export type PaymentGatewayUriQueryVariables = Exact<{
  eventKeyOrId: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  successCallbackUri: Scalars['String']['input'];
  failCallbackUri: Scalars['String']['input'];
  cancelCallbackUri: Scalars['String']['input'];
}>;


export type PaymentGatewayUriQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', event?: { __typename?: 'Event', viewerParticipant?: { __typename?: 'ViewerParticipant', id: string, accessIdentifier: string, bookings: Array<{ __typename?: 'Booking', id: string, bookingNr: string, bookingStatus: BookingStatus, payment?: { __typename?: 'Payment', gatewayUri?: string | null } | null }> } | null } | null } | null };

export type RegisterQueryVariables = Exact<{
  eventKeyOrId: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
}>;


export type RegisterQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', event?: { __typename?: 'Event', id: string, key: string, title: string, description?: string | null, authenticationMethods: Array<AuthenticationMethod>, multiBookable?: boolean | null, startDate?: any | null, endDate?: any | null, online: boolean, timezone: { __typename?: 'DateTimeZone', name: string, default: boolean }, onlineEventSettings?: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }> | null, payment?: { __typename?: 'PaymentSetting', currency: { __typename?: 'Currency', name: string } } | null, viewerRegistration?: { __typename?: 'Registration', note: string, participantDefinition: { __typename?: 'ParticipantDefinition', maximumCompanions?: number | null, publicParticipantOptIn: ParticipantFeatureSetting, representative: boolean, inputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }>, companionInputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }> }, participantRequirements: Array<{ __typename?: 'RegistrationAttachment', name: string, text: string, file?: { __typename?: 'File', title: string, caption: string, resource?: any | null } | null }>, inputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }> } | null, viewerParticipant?: { __typename?: 'ViewerParticipant', id: string, accessIdentifier: string, bookings: Array<{ __typename?: 'Booking', id: string, bookingNr: string, bookingStatus: BookingStatus, creationDate?: any | null, includingVat: boolean, deletable: boolean, discount: number, discountVatPrice: number, registrationPrice: number, registrationVatPrice: number, eTicketUrl?: string | null, participant: { __typename?: 'ViewerParticipant', id: string, displayName: string, email: string, public: boolean, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }>, representative?: { __typename?: 'Companion', id: string, displayName: string, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }> } | null }, payment?: { __typename?: 'Payment', onlinePaymentRequired: boolean, commissionRate: number, commissionPrice: number, commissionVatPrice: number, totalPrice: number, totalVatPrice: number, vatRate: number, paymentStatus: PaymentStatus, totalPriceInclVatRounded: number, paymentType: { __typename?: 'PaymentType', name: string, gateway: boolean }, currency: { __typename?: 'Currency', name: string } } | null, bookingOperations: Array<{ __typename?: 'BookingOperation', id: string, bookingOperationStatus: BookingOperationStatus, groupBooking?: { __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null } | null, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }>, operation: { __typename?: 'Operation', id: string, title: string, description: string, online: boolean, price?: number | null, marketPrice?: number | null, priceBreakdown: string, parentId: string, operationDates: Array<{ __typename?: 'OperationDate', startDate: any, endDate: any }>, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, venue?: { __typename?: 'Venue', name: string } | null, capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, waitinglist?: { __typename?: 'Waitinglist', capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null } | null, viewerBookable?: { __typename?: 'Bookable', waitinglist: boolean, minimum: number, maximum: number, maximumCompanions?: number | null } | null, inputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }>, groupBookingDefinition?: { __typename?: 'GroupBookingDefinition', minimumGroupParticipants: number, maximumGroupParticipants?: number | null, groupCapacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, viewerGroupBookable?: { __typename?: 'Bookable', maximum: number } | null } | null, groupBookings?: { __typename?: 'GroupBookingCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null }> } | null }, companion?: { __typename?: 'Companion', id: string, displayName: string, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }> } | null }>, groupedBookingOperations: Array<{ __typename?: 'BookingOperationAggregation', count: number, bookingOperationStatus: BookingOperationStatus, vatRate: number, discount: number, discountVatPrice: number, discountPercentage: number, totalPrice: number, totalVatPrice: number, operationPrice: number, operation: { __typename?: 'Operation', id: string, title: string, description: string, online: boolean, price?: number | null, marketPrice?: number | null, priceBreakdown: string, parentId: string, operationDates: Array<{ __typename?: 'OperationDate', startDate: any, endDate: any }>, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, venue?: { __typename?: 'Venue', name: string } | null, capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, waitinglist?: { __typename?: 'Waitinglist', capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null } | null, viewerBookable?: { __typename?: 'Bookable', waitinglist: boolean, minimum: number, maximum: number, maximumCompanions?: number | null } | null, inputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }>, groupBookingDefinition?: { __typename?: 'GroupBookingDefinition', minimumGroupParticipants: number, maximumGroupParticipants?: number | null, groupCapacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, viewerGroupBookable?: { __typename?: 'Bookable', maximum: number } | null } | null, groupBookings?: { __typename?: 'GroupBookingCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null }> } | null }, bookingOperations: Array<{ __typename?: 'BookingOperation', id: string, bookingOperationStatus: BookingOperationStatus, groupBooking?: { __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null } | null, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }>, companion?: { __typename?: 'Companion', id: string, displayName: string, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }> } | null }> }>, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }> }>, companions: Array<{ __typename?: 'Companion', id: string, displayName: string, inputFieldValues: Array<{ __typename?: 'BooleanInputFieldValue', selected: boolean, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'DateInputFieldValue', date?: any | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'FileInputFieldValue', file?: { __typename?: 'File', title: string, resource?: any | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ImageInputFieldValue', image?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'ListStringInputFieldValue', values: Array<string>, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } } | { __typename?: 'StringInputFieldValue', value: string, inputField: { __typename?: 'CheckboxField', identifier: string, label: string } | { __typename?: 'DatePickerField', identifier: string, label: string } | { __typename?: 'FileUploadField', identifier: string, label: string } | { __typename?: 'ImageUploadField', identifier: string, label: string } | { __typename?: 'MultiLineTextField', identifier: string, label: string } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string } | { __typename?: 'SingleLineTextField', identifier: string, label: string } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string } | { __typename?: 'StaticTextField', identifier: string, label: string } }> }> } | null, operations?: Array<{ __typename?: 'Operation', id: string, title: string, description: string, online: boolean, price?: number | null, marketPrice?: number | null, priceBreakdown: string, parentId: string, operationDates: Array<{ __typename?: 'OperationDate', startDate: any, endDate: any }>, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, venue?: { __typename?: 'Venue', name: string } | null, capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, waitinglist?: { __typename?: 'Waitinglist', capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null } | null, viewerBookable?: { __typename?: 'Bookable', waitinglist: boolean, minimum: number, maximum: number, maximumCompanions?: number | null } | null, inputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }>, groupBookingDefinition?: { __typename?: 'GroupBookingDefinition', minimumGroupParticipants: number, maximumGroupParticipants?: number | null, groupCapacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, viewerGroupBookable?: { __typename?: 'Bookable', maximum: number } | null } | null, groupBookings?: { __typename?: 'GroupBookingCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null }> } | null }> | null, subEvents?: Array<{ __typename?: 'SubEvent', id: string, title: string, description: string, multiBookable: boolean, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, operations: Array<{ __typename?: 'Operation', id: string, title: string, description: string, online: boolean, price?: number | null, marketPrice?: number | null, priceBreakdown: string, parentId: string, operationDates: Array<{ __typename?: 'OperationDate', startDate: any, endDate: any }>, onlineEventSettings: Array<{ __typename?: 'ExternalOnlineEventSetting', description?: string | null, id: string, timing: OnlineEventTiming, url: string } | { __typename?: 'InternalOnlineEventSetting', description?: string | null, fileExtension?: string | null, id: string, timing: OnlineEventTiming, url: string }>, venue?: { __typename?: 'Venue', name: string } | null, capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, waitinglist?: { __typename?: 'Waitinglist', capacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null } | null, viewerBookable?: { __typename?: 'Bookable', waitinglist: boolean, minimum: number, maximum: number, maximumCompanions?: number | null } | null, inputFields: Array<{ __typename?: 'CheckboxField', identifier: string, label: string, required: boolean, defaultCheckedValue: boolean } | { __typename?: 'DatePickerField', identifier: string, label: string, required: boolean, defaultDateValue?: any | null } | { __typename?: 'FileUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'ImageUploadField', identifier: string, label: string, required: boolean } | { __typename?: 'MultiLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'MultiSelectCheckboxesField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleLineTextField', identifier: string, label: string, defaultValue: string, placeholder: string, required: boolean, validator?: InputFieldValidator | null } | { __typename?: 'SingleSelectDropdownField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'SingleSelectRadiobuttonsField', identifier: string, label: string, required: boolean, options: Array<{ __typename?: 'SelectFieldOption', label: string, value: string, selected: boolean }> } | { __typename?: 'StaticTextField', identifier: string, label: string, text: string }>, groupBookingDefinition?: { __typename?: 'GroupBookingDefinition', minimumGroupParticipants: number, maximumGroupParticipants?: number | null, groupCapacity?: { __typename?: 'Capacity', available?: number | null, minimum?: number | null, maximum?: number | null } | null, viewerGroupBookable?: { __typename?: 'Bookable', maximum: number } | null } | null, groupBookings?: { __typename?: 'GroupBookingCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'GroupBooking', id: string, name: string, description: string, public: boolean, participantCount: number, participants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null, primaryParticipant: { __typename?: 'GenericParticipant', id: string, displayName: string, userId?: string | null } | { __typename?: 'ViewerParticipant', id: string, displayName: string, userId?: string | null }, invitedParticipants?: Array<{ __typename?: 'GenericParticipant', id: string, displayName: string } | { __typename?: 'ViewerParticipant', id: string, displayName: string }> | null }> } | null }> }> | null } | null } | null };

export type SpeakersQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  eventKeyOrId: Scalars['String']['input'];
  length?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SpeakersQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', event?: { __typename?: 'Event', id: string, speakerCollection?: { __typename?: 'SpeakerCollection', itemCount: number, totalCount: number, items: Array<{ __typename?: 'Speaker', id: string, firstName: string, lastName: string, displayName: string, jobTitle: string, organization: string, bio: string, thumbnail?: { __typename?: 'Image', title: string, thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, socialMedia: Array<{ __typename?: 'AdditionalSocialMediaField', label: string, url: string, platform: SocialMediaPlatform }> }> } | null } | null } | null };

export type UserQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  length?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', user?: { __typename?: 'GenericUser', id: string, firstName: string, lastName: string, displayName: string, thumbnail?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, image?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, organizerEvents?: { __typename?: 'EventTeaserCollection', totalCount: number, itemCount: number, items: Array<{ __typename?: 'EventTeaser', id: string, key: string, title: string, startDate?: any | null, endDate?: any | null, lowestPrice?: number | null, currencyName?: string | null, online: boolean, promoted: boolean, venueName?: string | null, eventTypeKey: string, eventTypeName: string, timezone: { __typename?: 'DateTimeZone', name: string, default: boolean }, image?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, capacity: { __typename?: 'EventCapacity', count: number, maximum?: number | null, available?: number | null, waitinglist: boolean }, operations: Array<{ __typename?: 'OperationTeaser', id: string, title: string, online: boolean, operationDates: Array<{ __typename?: 'OperationDateTeaser', startDate: any, endDate: any }> }> }> } | null, participantEvents?: { __typename?: 'EventTeaserCollection', totalCount: number, itemCount: number, items: Array<{ __typename?: 'EventTeaser', id: string, key: string, title: string, startDate?: any | null, endDate?: any | null, lowestPrice?: number | null, currencyName?: string | null, online: boolean, promoted: boolean, venueName?: string | null, eventTypeKey: string, eventTypeName: string, timezone: { __typename?: 'DateTimeZone', name: string, default: boolean }, image?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, capacity: { __typename?: 'EventCapacity', count: number, maximum?: number | null, available?: number | null, waitinglist: boolean }, operations: Array<{ __typename?: 'OperationTeaser', id: string, title: string, online: boolean, operationDates: Array<{ __typename?: 'OperationDateTeaser', startDate: any, endDate: any }> }> }> } | null } | { __typename?: 'ViewerUser', id: string, firstName: string, lastName: string, displayName: string, reservationEvents?: { __typename?: 'EventTeaserCollection', totalCount: number, itemCount: number, items: Array<{ __typename?: 'EventTeaser', id: string, key: string, title: string, startDate?: any | null, endDate?: any | null, lowestPrice?: number | null, currencyName?: string | null, online: boolean, promoted: boolean, venueName?: string | null, eventTypeKey: string, eventTypeName: string, timezone: { __typename?: 'DateTimeZone', name: string, default: boolean }, image?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, capacity: { __typename?: 'EventCapacity', count: number, maximum?: number | null, available?: number | null, waitinglist: boolean }, operations: Array<{ __typename?: 'OperationTeaser', id: string, title: string, online: boolean, operationDates: Array<{ __typename?: 'OperationDateTeaser', startDate: any, endDate: any }> }> }> } | null, thumbnail?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, image?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, organizerEvents?: { __typename?: 'EventTeaserCollection', totalCount: number, itemCount: number, items: Array<{ __typename?: 'EventTeaser', id: string, key: string, title: string, startDate?: any | null, endDate?: any | null, lowestPrice?: number | null, currencyName?: string | null, online: boolean, promoted: boolean, venueName?: string | null, eventTypeKey: string, eventTypeName: string, timezone: { __typename?: 'DateTimeZone', name: string, default: boolean }, image?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, capacity: { __typename?: 'EventCapacity', count: number, maximum?: number | null, available?: number | null, waitinglist: boolean }, operations: Array<{ __typename?: 'OperationTeaser', id: string, title: string, online: boolean, operationDates: Array<{ __typename?: 'OperationDateTeaser', startDate: any, endDate: any }> }> }> } | null, participantEvents?: { __typename?: 'EventTeaserCollection', totalCount: number, itemCount: number, items: Array<{ __typename?: 'EventTeaser', id: string, key: string, title: string, startDate?: any | null, endDate?: any | null, lowestPrice?: number | null, currencyName?: string | null, online: boolean, promoted: boolean, venueName?: string | null, eventTypeKey: string, eventTypeName: string, timezone: { __typename?: 'DateTimeZone', name: string, default: boolean }, image?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, capacity: { __typename?: 'EventCapacity', count: number, maximum?: number | null, available?: number | null, waitinglist: boolean }, operations: Array<{ __typename?: 'OperationTeaser', id: string, title: string, online: boolean, operationDates: Array<{ __typename?: 'OperationDateTeaser', startDate: any, endDate: any }> }> }> } | null } | null } | null };

export type VenuesQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  length?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  filterEventTypeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type VenuesQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', venues?: { __typename?: 'VenueCollection', items: Array<{ __typename?: 'Venue', id: string, name: string }> } | null } | null };

export type ViewerUserQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
}>;


export type ViewerUserQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', viewerUser?: { __typename?: 'ViewerUser', id: string, username: string, gender?: Gender | null, firstName: string, lastName: string, displayName: string, email: string, phone: string, language?: string | null, thumbnail?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null, image?: { __typename?: 'Image', thumbnail?: { __typename?: 'Thumbnail', resource?: any | null } | null } | null } | null } | null };

export const AdditionalFieldsFragmentDoc = gql`
    fragment AdditionalFields on AdditionalField {
  label
  ... on AdditionalMultilineField {
    text
  }
  ... on AdditionalEmailField {
    email
  }
  ... on AdditionalLinkField {
    text
    url
    target
  }
  ... on AdditionalImageListField {
    images {
      title
      caption
      thumbnail(width: 2712) {
        resource
      }
    }
  }
  ... on AdditionalFileListField {
    files {
      title
      caption
      resource
    }
  }
}
    `;
export const InputValueFragmentDoc = gql`
    fragment InputValue on InputFieldValue {
  inputField {
    identifier
    label
  }
  ... on StringInputFieldValue {
    value: stringValue
  }
  ... on ListStringInputFieldValue {
    values: stringValues
  }
  ... on BooleanInputFieldValue {
    selected: booleanValue
  }
  ... on DateInputFieldValue {
    date: dateValue
  }
  ... on FileInputFieldValue {
    file: fileValue {
      title
      resource
    }
  }
  ... on ImageInputFieldValue {
    image: imageValue {
      title
      thumbnail(width: 64, height: 64) {
        resource
      }
    }
  }
}
    `;
export const CompanionFragmentDoc = gql`
    fragment Companion on Companion {
  id
  displayName
  inputFieldValues {
    ...InputValue
  }
}
    ${InputValueFragmentDoc}`;
export const GroupBookingFragmentDoc = gql`
    fragment GroupBooking on GroupBooking {
  id
  name
  description
  public
  participants {
    id
    displayName
  }
  primaryParticipant {
    id
    displayName
    userId
  }
  participantCount
  invitedParticipants {
    id
    displayName
  }
}
    `;
export const OnlineEventSettingsFragmentDoc = gql`
    fragment OnlineEventSettings on OnlineEventSetting {
  id
  timing
  url
  ... on InternalOnlineEventSetting {
    description
    fileExtension
  }
  ... on ExternalOnlineEventSetting {
    description
  }
}
    `;
export const InputFragmentDoc = gql`
    fragment Input on InputField {
  ... on StaticTextField {
    identifier
    label
    text
  }
  ... on SingleLineTextField {
    identifier
    label
    defaultValue
    placeholder
    required
    validator
  }
  ... on MultiLineTextField {
    identifier
    label
    defaultValue
    placeholder
    required
    validator
  }
  ... on SingleSelectRadiobuttonsField {
    identifier
    label
    options {
      label
      value
      selected
    }
    required
  }
  ... on CheckboxField {
    identifier
    label
    defaultCheckedValue: defaultValue
    required
  }
  ... on MultiSelectCheckboxesField {
    identifier
    label
    options {
      label
      value
      selected
    }
    required
  }
  ... on SingleSelectDropdownField {
    identifier
    label
    options {
      label
      value
      selected
    }
    required
  }
  ... on DatePickerField {
    identifier
    label
    defaultDateValue: defaultValue
    required
  }
  ... on FileUploadField {
    identifier
    label
    required
  }
  ... on ImageUploadField {
    identifier
    label
    required
  }
}
    `;
export const OperationFragmentDoc = gql`
    fragment Operation on Operation {
  id
  title
  description
  operationDates {
    startDate
    endDate
  }
  online
  onlineEventSettings {
    ...OnlineEventSettings
  }
  venue {
    name
  }
  price
  marketPrice
  priceBreakdown
  capacity {
    available
    minimum
    maximum
  }
  waitinglist {
    capacity {
      available
      minimum
      maximum
    }
  }
  viewerBookable {
    waitinglist
    minimum
    maximum
    maximumCompanions
  }
  inputFields {
    ...Input
  }
  groupBookingDefinition {
    groupCapacity {
      available
      minimum
      maximum
    }
    minimumGroupParticipants
    maximumGroupParticipants
    viewerGroupBookable {
      maximum
    }
  }
  groupBookings(limit: {length: 100}) {
    itemCount
    totalCount
    items {
      ...GroupBooking
    }
  }
  parentId
}
    ${OnlineEventSettingsFragmentDoc}
${InputFragmentDoc}
${GroupBookingFragmentDoc}`;
export const BookingFragmentDoc = gql`
    fragment Booking on Booking {
  id
  bookingNr
  bookingStatus
  creationDate
  includingVat
  deletable
  discount
  discountVatPrice
  registrationPrice
  registrationVatPrice
  eTicketUrl
  participant {
    id
    displayName
    email
    inputFieldValues {
      ...InputValue
    }
    public
    representative {
      ...Companion
    }
  }
  payment {
    paymentType {
      name
      gateway
    }
    onlinePaymentRequired
    commissionRate
    commissionPrice
    commissionVatPrice
    totalPrice
    totalVatPrice
    vatRate
    paymentStatus
    totalPriceInclVatRounded
    currency {
      name
    }
  }
  bookingOperations {
    id
    bookingOperationStatus
    groupBooking {
      ...GroupBooking
    }
    inputFieldValues {
      ...InputValue
    }
    operation {
      ...Operation
    }
    companion {
      ...Companion
    }
  }
  groupedBookingOperations {
    count
    bookingOperationStatus
    vatRate
    discount
    discountVatPrice
    discountPercentage
    totalPrice
    totalVatPrice
    operation {
      ...Operation
    }
    operationPrice
    bookingOperations {
      id
      bookingOperationStatus
      groupBooking {
        ...GroupBooking
      }
      inputFieldValues {
        ...InputValue
      }
      companion {
        ...Companion
      }
    }
  }
  inputFieldValues {
    ...InputValue
  }
}
    ${InputValueFragmentDoc}
${CompanionFragmentDoc}
${GroupBookingFragmentDoc}
${OperationFragmentDoc}`;
export const BrandingFragmentDoc = gql`
    fragment Branding on BrandingSetting {
  logo {
    originalWidth: width
    originalHeight: height
    thumbnail(height: 120) {
      resource
    }
  }
  primaryColor
  secondaryColor
  backgroundColor
  fontFile
  fontFamily
}
    `;
export const DateTimeZoneFragmentDoc = gql`
    fragment DateTimeZone on DateTimeZone {
  name
  default
}
    `;
export const EventTeaserFragmentDoc = gql`
    fragment EventTeaser on EventTeaser {
  id
  key
  title
  timezone {
    ...DateTimeZone
  }
  startDate
  endDate
  image {
    thumbnail(width: 640, height: 360) {
      resource
    }
  }
  capacity {
    count
    maximum
    available
    waitinglist
  }
  lowestPrice
  currencyName
  online
  promoted
  venueName
  eventTypeKey
  eventTypeName
  operations {
    id
    title
    operationDates {
      startDate
      endDate
    }
    online
  }
}
    ${DateTimeZoneFragmentDoc}`;
export const ImageFragmentDoc = gql`
    fragment Image on Image {
  title
  caption
  thumbnail {
    width
    height
    resource
  }
}
    `;
export const RegisterOperationFragmentDoc = gql`
    fragment RegisterOperation on Operation {
  id
  title
  description
  operationDates {
    startDate
    endDate
  }
  online
  onlineEventSettings {
    ...OnlineEventSettings
  }
  venue {
    name
  }
  price
  marketPrice
  priceBreakdown
  capacity {
    available
    minimum
    maximum
  }
  waitinglist {
    capacity {
      available
      minimum
      maximum
    }
  }
  viewerBookable(ignoreParticipantBookings: true) {
    waitinglist
    minimum
    maximum
    maximumCompanions
  }
  inputFields {
    ...Input
  }
  groupBookingDefinition {
    groupCapacity {
      available
      minimum
      maximum
    }
    minimumGroupParticipants
    maximumGroupParticipants
    viewerGroupBookable(ignoreParticipantBookings: true) {
      maximum
    }
  }
  groupBookings(limit: {length: 100}) {
    itemCount
    totalCount
    items {
      ...GroupBooking
    }
  }
  parentId
}
    ${OnlineEventSettingsFragmentDoc}
${InputFragmentDoc}
${GroupBookingFragmentDoc}`;
export const AcceptInviteeDocument = gql`
    mutation AcceptInvitee($token: String!, $eventId: ID!) {
  viewer(token: $token) {
    event(id: $eventId) {
      viewerInvitee {
        accept {
          inputError {
            message
          }
          object {
            inviteeStatus
          }
        }
      }
    }
  }
}
    `;
export const AccessCodeLoginDocument = gql`
    mutation AccessCodeLogin($accessCode: String!, $eventId: ID!) {
  authentication {
    createTokenByAccessCode(
      accessCode: {accessCode: $accessCode, eventId: $eventId}
    ) {
      token
    }
  }
}
    `;
export const AddGroupBookingParticipantDocument = gql`
    mutation AddGroupBookingParticipant($token: String!, $eventId: ID!, $groupBookingId: ID!, $participantUsernameOrEmail: String!) {
  viewer(token: $token) {
    event(id: $eventId) {
      viewerParticipant {
        addGroupBookingParticipant(
          groupBookingParticipant: {id: $groupBookingId, participantUsernameOrEmail: $participantUsernameOrEmail}
        ) {
          inputError {
            message
          }
        }
      }
    }
  }
}
    `;
export const CancelBookingDocument = gql`
    mutation CancelBooking($token: String!, $eventId: ID!, $bookingId: ID!) {
  viewer(token: $token) {
    event(id: $eventId) {
      viewerParticipant {
        cancelBooking(id: $bookingId) {
          inputError {
            message
          }
        }
      }
    }
  }
}
    `;
export const CheckInParticipantDocument = gql`
    mutation CheckInParticipant($token: String, $eventId: ID!, $onlineEventSettingId: ID!) {
  viewer(token: $token) {
    event(id: $eventId) {
      viewerParticipant {
        checkInByOnlineEventSetting(id: $onlineEventSettingId) {
          inputError {
            message
          }
        }
      }
    }
  }
}
    `;
export const ConfirmBookingDocument = gql`
    mutation ConfirmBooking($token: String!, $eventId: ID!, $bookingId: ID!) {
  viewer(token: $token) {
    event(id: $eventId) {
      viewerParticipant {
        confirmBooking(id: $bookingId) {
          inputError {
            message
          }
          object {
            bookingStatus
          }
        }
      }
    }
  }
}
    `;
export const ConfirmBookingOperationsDocument = gql`
    mutation ConfirmBookingOperations($token: String!, $eventId: ID!, $bookingOperationIds: [ID!]!) {
  viewer(token: $token) {
    event(id: $eventId) {
      viewerParticipant {
        confirmBookingOperations(ids: $bookingOperationIds) {
          inputError {
            message
          }
        }
      }
    }
  }
}
    `;
export const CreateBookingDocument = gql`
    mutation CreateBooking($token: String, $locale: String!, $eventId: ID!, $operations: [BookingOperationCreateInput!]!, $companions: [CompanionBookingOperationCreateInput!]) {
  viewer(token: $token, language: $locale) {
    event(id: $eventId) {
      createBooking(
        booking: {bookingOperations: $operations, companions: $companions}
      ) {
        inputError {
          message
        }
        object {
          bookingNr
          participant {
            accessIdentifier
          }
        }
      }
    }
  }
}
    `;
export const CreateCancellationDocument = gql`
    mutation CreateCancellation($token: String, $eventId: ID!, $inputFieldValues: [InputFieldValueInput!]!) {
  viewer(token: $token) {
    event(id: $eventId) {
      createCancellation(
        cancellation: {participant: {inputFieldValues: $inputFieldValues}}
      ) {
        object {
          participant {
            accessIdentifier
          }
        }
        inputError {
          message
        }
      }
    }
  }
}
    `;
export const CreateCommentDocument = gql`
    mutation CreateComment($token: String, $eventId: ID!, $text: String!, $captcha: String) {
  viewer(token: $token) {
    event(id: $eventId) {
      createComment(comment: {text: $text, captcha: $captcha}) {
        inputError {
          message
        }
      }
    }
  }
}
    `;
export const CreateEventDocument = gql`
    mutation CreateEvent($token: String, $title: String!, $image: Resource, $eventTypeId: ID!, $categoryIds: [ID!], $description: String, $venueId: ID, $newVenue: VenueCreateInput, $onlineEventSetting: ExternalOnlineEventSettingInput, $operationDates: [OperationDateCreateInput!]!, $deadline: DateTime, $minParticipant: Int, $maxParticipant: Int, $remark: String) {
  viewer(token: $token) {
    createEvent(
      event: {title: $title, image: $image, eventTypeId: $eventTypeId, categoryIds: $categoryIds, description: $description, venueId: $venueId, newVenue: $newVenue, onlineEventSetting: $onlineEventSetting, operationDates: $operationDates, deadline: $deadline, minParticipant: $minParticipant, maxParticipant: $maxParticipant, remark: $remark}
    ) {
      inputError {
        message
      }
    }
  }
}
    `;
export const CreateUserDocument = gql`
    mutation CreateUser($user: UserCreateInput!) {
  viewer {
    user {
      createUser(user: $user) {
        inputError {
          message
        }
        success
      }
    }
  }
}
    `;
export const DeleteBookingDocument = gql`
    mutation DeleteBooking($token: String!, $eventId: ID!, $bookingId: ID!) {
  viewer(token: $token) {
    event(id: $eventId) {
      viewerParticipant {
        deleteBooking(id: $bookingId) {
          inputError {
            message
          }
        }
      }
    }
  }
}
    `;
export const DeleteBookingOperationsDocument = gql`
    mutation DeleteBookingOperations($token: String!, $eventId: ID!, $bookingOperationIds: [ID!]!) {
  viewer(token: $token) {
    event(id: $eventId) {
      viewerParticipant {
        deleteBookingOperations(ids: $bookingOperationIds) {
          inputError {
            message
          }
        }
      }
    }
  }
}
    `;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($token: String, $eventId: ID!, $commentId: ID!) {
  viewer(token: $token) {
    event(id: $eventId) {
      deleteComment(id: $commentId) {
        inputError {
          message
        }
      }
    }
  }
}
    `;
export const ParticipantLoginDocument = gql`
    mutation ParticipantLogin($accessIdentifier: String!) {
  authentication {
    createTokenByParticipant(participant: {accessIdentifier: $accessIdentifier}) {
      token
    }
  }
}
    `;
export const RejectInviteeDocument = gql`
    mutation RejectInvitee($token: String!, $eventId: ID!) {
  viewer(token: $token) {
    event(id: $eventId) {
      viewerInvitee {
        reject {
          inputError {
            message
          }
          object {
            inviteeStatus
          }
        }
      }
    }
  }
}
    `;
export const RemoveGroupBookingParticipantDocument = gql`
    mutation RemoveGroupBookingParticipant($token: String!, $eventId: ID!, $groupBookingId: ID!, $participantId: ID!) {
  viewer(token: $token) {
    event(id: $eventId) {
      viewerParticipant {
        removeGroupBookingParticipant(
          groupBookingParticipant: {id: $groupBookingId, participantId: $participantId}
        ) {
          inputError {
            message
          }
        }
      }
    }
  }
}
    `;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($user: UserInput!) {
  viewer {
    user {
      requestPasswordReset(user: $user) {
        inputError {
          message
        }
        success
      }
    }
  }
}
    `;
export const ResendBookingConfirmationByParticipantEmailDocument = gql`
    mutation ResendBookingConfirmationByParticipantEmail($eventId: ID!, $email: String!) {
  viewer {
    event(id: $eventId) {
      resendBookingConfirmationByParticipantEmail(email: $email) {
        inputError {
          message
        }
        success
      }
    }
  }
}
    `;
export const ResendBookingConfirmationDocument = gql`
    mutation ResendBookingConfirmation($token: String!, $eventId: ID!, $bookingId: ID!) {
  viewer(token: $token) {
    event(id: $eventId) {
      viewerParticipant {
        resendBookingConfirmation(id: $bookingId) {
          inputError {
            message
          }
        }
      }
    }
  }
}
    `;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($token: String!, $password: String!) {
  viewer {
    user {
      resetPassword(password: {token: $token, password: $password}) {
        inputError {
          message
        }
      }
    }
  }
}
    `;
export const SendEmailDocument = gql`
    mutation SendEmail($token: String, $eventId: ID!, $message: MessageInput!, $sender: MessageSenderInput) {
  viewer(token: $token) {
    event(id: $eventId) {
      sendEmailMessage(message: $message, sender: $sender) {
        inputError {
          message
        }
        success
      }
    }
  }
}
    `;
export const SendGlobalEmailDocument = gql`
    mutation SendGlobalEmail($token: String, $message: MessageInput!, $sender: MessageSenderInput) {
  viewer(token: $token) {
    sendEmailMessage(message: $message, sender: $sender) {
      inputError {
        message
      }
      success
    }
  }
}
    `;
export const SsoLoginDocument = gql`
    mutation SSOLogin($callbackUri: String!) {
  authentication {
    ssoUri: getSsoUri(callbackUri: $callbackUri)
  }
}
    `;
export const UpdateBookingDocument = gql`
    mutation UpdateBooking($token: String, $eventId: ID!, $bookingId: ID!, $operations: [BookingOperationCreateInput!], $companions: [CompanionBookingOperationCreateInput!]) {
  viewer(token: $token) {
    event(id: $eventId) {
      viewerParticipant {
        updateBooking(
          booking: {id: $bookingId, bookingOperations: $operations, companions: $companions}
        ) {
          inputError {
            message
          }
          object {
            bookingNr
            participant {
              accessIdentifier
            }
          }
        }
      }
    }
  }
}
    `;
export const UpdateGroupBookingDocument = gql`
    mutation UpdateGroupBooking($token: String!, $eventId: ID!, $groupBookingId: ID!, $description: String!, $public: Boolean!) {
  viewer(token: $token) {
    event(id: $eventId) {
      viewerParticipant {
        updateGroupBooking(
          groupBooking: {id: $groupBookingId, description: $description, public: $public}
        ) {
          inputError {
            message
          }
        }
      }
    }
  }
}
    `;
export const UpdateParticipantDocument = gql`
    mutation UpdateParticipant($token: String!, $eventId: ID!, $inputFieldValues: [InputFieldValueInput!]!, $representative: CompanionCreateInput, $public: Boolean, $bookingId: ID!, $bookingInputFieldValues: [InputFieldValueInput!]!) {
  viewer(token: $token) {
    event(id: $eventId) {
      viewerParticipant {
        updateParticipant(
          participant: {inputFieldValues: $inputFieldValues, public: $public, representative: $representative}
        ) {
          inputError {
            message
          }
        }
        updateBooking(
          booking: {id: $bookingId, inputFieldValues: $bookingInputFieldValues}
        ) {
          inputError {
            message
          }
        }
      }
    }
  }
}
    `;
export const UpdateUserDocument = gql`
    mutation UpdateUser($token: String!, $user: UserUpdateInput!) {
  viewer(token: $token) {
    updateUser(user: $user) {
      inputError {
        message
      }
    }
  }
}
    `;
export const UsernamePasswordLoginDocument = gql`
    mutation UsernamePasswordLogin($username: String!, $password: String!) {
  authentication {
    createTokenByUsernamePassword(
      usernamePassword: {username: $username, password: $password}
    ) {
      token
    }
  }
}
    `;
export const AppDocument = gql`
    query App {
  app {
    authenticationMethods
    branding {
      ...Branding
    }
    eventCreation
    userRegistration
  }
}
    ${BrandingFragmentDoc}`;
export const BookingsDocument = gql`
    query Bookings($token: String, $locale: String!, $eventKeyOrId: String!) {
  viewer(token: $token, language: $locale) {
    authenticationMethod
    event(key: $eventKeyOrId) {
      id
      key
      title
      authenticationMethods
      timezone {
        ...DateTimeZone
      }
      startDate
      endDate
      deadline
      capacity {
        available
        waitinglist
        bookable
      }
      onlineEventSettings {
        ...OnlineEventSettings
      }
      viewerRegistration {
        running
        participantDefinition {
          cancellation
          cancellationInputFields {
            ...Input
          }
        }
      }
      viewerParticipant {
        id
        bookings(statuses: [CONFIRMED, PENDING, REQUESTED]) {
          ...Booking
        }
        cancellation {
          id
        }
        inputFieldValues {
          ...InputValue
        }
      }
      operations {
        ...Operation
        viewerBookable {
          maximum
        }
      }
      subEvents {
        id
        title
        startDate
        endDate
        onlineEventSettings {
          ...OnlineEventSettings
        }
        operations {
          ...Operation
          viewerBookable {
            maximum
          }
        }
      }
    }
  }
}
    ${DateTimeZoneFragmentDoc}
${OnlineEventSettingsFragmentDoc}
${InputFragmentDoc}
${BookingFragmentDoc}
${InputValueFragmentDoc}
${OperationFragmentDoc}`;
export const CategoriesAndEventTypesDocument = gql`
    query CategoriesAndEventTypes($token: String, $locale: String!, $filterActiveOnly: Boolean = false, $filterAppLibraryOnly: Boolean!, $filterEventCreationOnly: Boolean!) {
  viewer(token: $token, language: $locale) {
    categories(filter: {filterAppLibraryOnly: true}) {
      id
      name
      image {
        thumbnail(width: 486, height: 300) {
          resource
        }
      }
    }
    eventTypes(
      filter: {filterAppLibraryOnly: $filterAppLibraryOnly, filterEventCreationOnly: $filterEventCreationOnly}
    ) {
      id
      key
      name
      categories(filter: {filterActiveOnly: $filterActiveOnly}) {
        id
        name
      }
    }
  }
}
    `;
export const CommentsDocument = gql`
    query Comments($token: String, $locale: String, $eventKeyOrId: String!, $length: Int, $offset: Int) {
  viewer(token: $token, language: $locale) {
    event(key: $eventKeyOrId) {
      id
      comments(limit: {length: $length, offset: $offset}) {
        itemCount
        totalCount
        items {
          id
          firstName
          lastName
          userId
          thumbnail {
            thumbnail(width: 100, height: 100) {
              resource
            }
          }
          creationDate
          text
          deletable
        }
      }
    }
  }
}
    `;
export const EventDatesDocument = gql`
    query EventDates($token: String, $locale: String!, $length: Int!, $search: String, $filterFromDate: DateTime!, $filterToDate: DateTime!, $filterCategoryIds: [ID!], $filterEventTypeIds: [ID!]) {
  viewer(token: $token, language: $locale) {
    dates: eventTeasers(
      limit: {length: $length}
      filter: {search: $search, filterFromDate: $filterFromDate, filterToDate: $filterToDate, filterCategoryIds: $filterCategoryIds, filterEventTypeIds: $filterEventTypeIds, filterAppLibraryOnly: true}
    ) {
      items {
        timezone {
          ...DateTimeZone
        }
        operations {
          operationDates {
            startDate
            endDate
          }
        }
      }
    }
  }
}
    ${DateTimeZoneFragmentDoc}`;
export const EventDocument = gql`
    query Event($token: String, $locale: String!, $eventKeyOrId: String!) {
  viewer(token: $token, language: $locale) {
    event(key: $eventKeyOrId) {
      id
      key
      title
      authenticationMethods
      language {
        default
        available
      }
      timezone {
        ...DateTimeZone
      }
      startDate
      endDate
      deadline
      capacity {
        available
        waitinglist
        bookable
      }
      description
      image {
        small: thumbnail(width: 480, height: 320) {
          resource
        }
        medium: thumbnail(width: 960, height: 640) {
          resource
        }
        large: thumbnail(width: 1650, height: 1100) {
          resource
        }
      }
      wideImage: image {
        small: thumbnail(width: 600, height: 218) {
          resource
        }
        medium: thumbnail(width: 1200, height: 436) {
          resource
        }
        large: thumbnail(width: 2712, height: 986) {
          resource
        }
      }
      branding {
        ...Branding
      }
      layout
      payment {
        currency {
          name
        }
      }
      eventType {
        key
        name
        domain
        standaloneLibrary
        appLibrary
      }
      online
      onlineEventSettings {
        ...OnlineEventSettings
      }
      venue {
        name
        latitude
        longitude
      }
      lowestPrice
      viewerRegistration {
        running
        cancellation
        participantDefinition {
          publicParticipantOptIn
        }
      }
      viewerParticipant {
        id
        accessIdentifier
        firstName
        lastName
        displayName
        email
        cancellation {
          id
        }
      }
      viewerInvitee {
        id
        firstName
        lastName
        displayName
        inviteeStatus
        email
        phone
        language
        company
        jobTitle
        complianceProcess
        complianceFormDownloadUrl
        complianceFormUploadUrl
        respondable
        operation {
          id
          title
          venue {
            name
          }
          operationDates {
            startDate
            endDate
          }
          marketPrice
          priceBreakdown
        }
        companions {
          id
          displayName
        }
      }
      organizerUsers {
        id
        firstName
        lastName
        displayName
        thumbnail {
          thumbnail(width: 80, height: 80) {
            width
            height
            resource
          }
        }
      }
      organizerOrganizations {
        id
        name
        image {
          thumbnail(width: 80, height: 80) {
            width
            height
            resource
          }
        }
      }
      additionalFields {
        ...AdditionalFields
      }
      agendaFeature
      agenda {
        id
        title
        startDate
        endDate
        lead
        description
        image {
          ...Image
        }
        additionalFields {
          ...AdditionalFields
        }
        tags
        speakers {
          id
          firstName
          lastName
          displayName
          thumbnail {
            thumbnail(width: 400, height: 400) {
              resource
            }
          }
        }
        venue {
          name
        }
      }
      speakerFeature
      participantFeature
      viewerParticipantFeature
      commentFeature
      viewerCommentFeature
      operations {
        id
        title
        operationDates {
          startDate
          endDate
        }
        description
        online
        onlineEventSettings {
          ...OnlineEventSettings
        }
      }
      subEvents {
        id
        title
        startDate
        endDate
        description
        online
        onlineEventSettings {
          ...OnlineEventSettings
        }
        operations {
          id
          title
          operationDates {
            startDate
            endDate
          }
          description
          online
          onlineEventSettings {
            ...OnlineEventSettings
          }
          capacity {
            maximum
            available
          }
          totalBookingCounts {
            total
          }
        }
      }
    }
  }
}
    ${DateTimeZoneFragmentDoc}
${BrandingFragmentDoc}
${OnlineEventSettingsFragmentDoc}
${AdditionalFieldsFragmentDoc}
${ImageFragmentDoc}`;
export const EventTeasersDocument = gql`
    query EventTeasers($token: String, $locale: String!, $length: Int, $offset: Int, $search: String, $filterFromDate: DateTime, $filterToDate: DateTime, $filterCategoryIds: [ID!], $filterEventTypeIds: [ID!], $filterAppLibraryOnly: Boolean, $filterPromotedOnly: Boolean) {
  viewer(token: $token, language: $locale) {
    eventTeasers(
      limit: {length: $length, offset: $offset}
      filter: {search: $search, filterFromDate: $filterFromDate, filterToDate: $filterToDate, filterCategoryIds: $filterCategoryIds, filterEventTypeIds: $filterEventTypeIds, filterAppLibraryOnly: $filterAppLibraryOnly, filterPromotedOnly: $filterPromotedOnly}
    ) {
      itemCount
      totalCount
      items {
        ...EventTeaser
      }
    }
  }
}
    ${EventTeaserFragmentDoc}`;
export const EventTypeDocument = gql`
    query EventType($token: String, $locale: String!, $eventTypeKeyOrId: String!, $contentSectionKey: String, $categoriesFilterActiveOnly: Boolean = false, $eventTeasersLength: Int, $eventTeasersOffset: Int, $eventTeasersSearch: String, $eventTeasersFilterFromDate: DateTime, $eventTeasersFilterToDate: DateTime, $eventTeasersFilterCategoryIds: [ID!], $eventTeasersFilterPromotedOnly: Boolean) {
  viewer(token: $token, language: $locale) {
    eventType(key: $eventTypeKeyOrId) {
      id
      key
      name
      domain
      authenticationMethods
      standaloneLibrary
      eventCreation
      image {
        small: thumbnail(width: 600, height: 218) {
          resource
        }
        medium: thumbnail(width: 1200, height: 436) {
          resource
        }
        large: thumbnail(width: 2712, height: 986) {
          resource
        }
      }
      contentSection(key: $contentSectionKey) {
        id
        key
        title
        text
        additionalFields {
          ...AdditionalFields
        }
      }
      contentSections {
        id
        key
        title
      }
      categories(filter: {filterActiveOnly: $categoriesFilterActiveOnly}) {
        id
        name
      }
      eventTeasers(
        limit: {length: $eventTeasersLength, offset: $eventTeasersOffset}
        filter: {search: $eventTeasersSearch, filterFromDate: $eventTeasersFilterFromDate, filterToDate: $eventTeasersFilterToDate, filterCategoryIds: $eventTeasersFilterCategoryIds, filterPromotedOnly: $eventTeasersFilterPromotedOnly}
      ) {
        itemCount
        totalCount
        items {
          ...EventTeaser
        }
      }
      branding {
        ...Branding
      }
    }
  }
}
    ${AdditionalFieldsFragmentDoc}
${EventTeaserFragmentDoc}
${BrandingFragmentDoc}`;
export const LoginEventTypesDocument = gql`
    query LoginEventTypes($locale: String!) {
  viewer(language: $locale) {
    eventTypes(filter: {filterPublicLibraryOnly: true}) {
      id
      key
      url
      name
      image {
        thumbnail(width: 712, height: 474) {
          resource
        }
      }
    }
  }
}
    `;
export const ParticipantsDocument = gql`
    query Participants($token: String, $locale: String!, $eventKeyOrId: String!, $length: Int!, $offset: Int!) {
  viewer(token: $token, language: $locale) {
    event(key: $eventKeyOrId) {
      participants(limit: {length: $length, offset: $offset}) {
        itemCount
        totalCount
        items {
          id
          firstName
          lastName
          displayName
          thumbnail {
            thumbnail(width: 200, height: 200) {
              resource
            }
          }
          userId
        }
      }
    }
  }
}
    `;
export const PaymentGatewayUriDocument = gql`
    query PaymentGatewayUri($eventKeyOrId: String!, $token: String, $locale: String!, $successCallbackUri: String!, $failCallbackUri: String!, $cancelCallbackUri: String!) {
  viewer(token: $token, language: $locale) {
    event(key: $eventKeyOrId) {
      viewerParticipant {
        id
        accessIdentifier
        bookings {
          id
          bookingNr
          bookingStatus
          payment {
            gatewayUri(
              successCallbackUri: $successCallbackUri
              failCallbackUri: $failCallbackUri
              cancelCallbackUri: $cancelCallbackUri
            )
          }
        }
      }
    }
  }
}
    `;
export const RegisterDocument = gql`
    query Register($eventKeyOrId: String!, $token: String, $locale: String!) {
  viewer(token: $token, language: $locale) {
    event(key: $eventKeyOrId) {
      id
      key
      title
      description
      authenticationMethods
      multiBookable
      timezone {
        ...DateTimeZone
      }
      startDate
      endDate
      online
      onlineEventSettings {
        ...OnlineEventSettings
      }
      payment {
        currency {
          name
        }
      }
      viewerRegistration {
        note
        participantDefinition {
          maximumCompanions
          inputFields {
            ...Input
          }
          companionInputFields {
            ...Input
          }
          publicParticipantOptIn
          representative
        }
        participantRequirements {
          name
          text
          file {
            title
            caption
            resource
          }
        }
        inputFields {
          ...Input
        }
      }
      viewerParticipant {
        id
        accessIdentifier
        bookings(statuses: [RESERVED, CONFIRMED, PENDING, REQUESTED, EXPIRED]) {
          ...Booking
        }
        companions {
          ...Companion
        }
      }
      operations {
        ...RegisterOperation
      }
      subEvents {
        id
        title
        description
        multiBookable
        onlineEventSettings {
          ...OnlineEventSettings
        }
        operations {
          ...RegisterOperation
        }
      }
    }
  }
}
    ${DateTimeZoneFragmentDoc}
${OnlineEventSettingsFragmentDoc}
${InputFragmentDoc}
${BookingFragmentDoc}
${CompanionFragmentDoc}
${RegisterOperationFragmentDoc}`;
export const SpeakersDocument = gql`
    query Speakers($token: String, $locale: String, $eventKeyOrId: String!, $length: Int, $offset: Int) {
  viewer(token: $token, language: $locale) {
    event(key: $eventKeyOrId) {
      id
      speakerCollection(limit: {length: $length, offset: $offset}) {
        itemCount
        totalCount
        items {
          id
          firstName
          lastName
          displayName
          jobTitle
          organization
          bio
          thumbnail {
            title
            thumbnail(width: 400, height: 400) {
              resource
            }
          }
          socialMedia {
            label
            url
            platform
          }
        }
      }
    }
  }
}
    `;
export const UserDocument = gql`
    query User($token: String, $locale: String!, $id: ID, $length: Int, $offset: Int) {
  viewer(token: $token, language: $locale) {
    user(id: $id) {
      id
      firstName
      lastName
      displayName
      thumbnail {
        thumbnail(width: 300, height: 300) {
          resource
        }
      }
      image {
        thumbnail(width: 2600, height: 1000) {
          resource
        }
      }
      organizerEvents(limit: {length: $length, offset: $offset}) {
        totalCount
        itemCount
        items {
          ...EventTeaser
        }
      }
      participantEvents(limit: {length: $length, offset: $offset}) {
        totalCount
        itemCount
        items {
          ...EventTeaser
        }
      }
      ... on ViewerUser {
        reservationEvents(limit: {length: $length, offset: $offset}) {
          totalCount
          itemCount
          items {
            ...EventTeaser
          }
        }
      }
    }
  }
}
    ${EventTeaserFragmentDoc}`;
export const VenuesDocument = gql`
    query Venues($token: String, $locale: String!, $length: Int, $offset: Int, $search: String, $filterEventTypeId: ID) {
  viewer(token: $token, language: $locale) {
    venues(
      limit: {length: $length, offset: $offset}
      filter: {search: $search, filterEventTypeId: $filterEventTypeId}
    ) {
      items {
        id
        name
      }
    }
  }
}
    `;
export const ViewerUserDocument = gql`
    query ViewerUser($token: String, $locale: String!) {
  viewer(token: $token, language: $locale) {
    viewerUser {
      id
      username
      gender
      firstName
      lastName
      displayName
      email
      phone
      thumbnail {
        thumbnail(width: 300, height: 300) {
          resource
        }
      }
      image {
        thumbnail(width: 2600, height: 1000) {
          resource
        }
      }
      language
    }
  }
}
    `;